/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SsoCallbackImport } from './routes/sso-callback'
import { Route as UnauthImport } from './routes/_unauth'
import { Route as AuthImport } from './routes/_auth'
import { Route as CalendarRedirectIndexImport } from './routes/calendar-redirect/index'
import { Route as AuthIndexImport } from './routes/_auth/index'
import { Route as CalendarRedirectProviderZoomImport } from './routes/calendar-redirect/provider-zoom'
import { Route as CalendarRedirectProviderMsteamsImport } from './routes/calendar-redirect/provider-msteams'
import { Route as CalendarRedirectProviderGoogleMeetImport } from './routes/calendar-redirect/provider-google-meet'
import { Route as ApplicationDefinitionApplicationDefinitionIdImport } from './routes/application-definition/$applicationDefinitionId'
import { Route as UnauthSignupImport } from './routes/_unauth.signup'
import { Route as UnauthLoginImport } from './routes/_unauth.login'
import { Route as UnauthLandingImport } from './routes/_unauth.landing'
import { Route as UnauthForgotPasswordImport } from './routes/_unauth.forgot-password'
import { Route as AuthApplicationDefinitionImport } from './routes/_auth/application-definition'
import { Route as AuthUserImport } from './routes/_auth/_user'
import { Route as AuthSuperAdminImport } from './routes/_auth/_super-admin'
import { Route as AuthProjectImport } from './routes/_auth/_project'
import { Route as AuthCommunityImport } from './routes/_auth/_community'
import { Route as UnauthLandingIndexImport } from './routes/_unauth.landing.index'
import { Route as UnauthResetPasswordActivationCodeImport } from './routes/_unauth.reset-password.$activationCode'
import { Route as UnauthActivateCodeImport } from './routes/_unauth.activate.$code'
import { Route as AuthRequestDeclineInvitationImport } from './routes/_auth/request.decline-invitation'
import { Route as AuthRequestAcceptInvitationImport } from './routes/_auth/request.accept-invitation'
import { Route as AuthProjectProjectIdImport } from './routes/_auth/project.$projectId'
import { Route as AuthUserEditProfileImport } from './routes/_auth/_user/edit-profile'
import { Route as EventsPublicJoinTokenImport } from './routes/events.public.join.$token'
import { Route as ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationImport } from './routes/application-definition/$applicationDefinitionId.application.new-application'
import { Route as ApplicationDefinitionApplicationDefinitionIdApplicationCreateImport } from './routes/application-definition/$applicationDefinitionId.application.create'
import { Route as ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdImport } from './routes/application-definition/$applicationDefinitionId.application.$applicationId'
import { Route as UnauthLandingTabTabIdImport } from './routes/_unauth.landing.tab.$tabId'
import { Route as UnauthLandingRequestRequestIdImport } from './routes/_unauth.landing.request.$requestId'
import { Route as UnauthLandingProjectsCommunityIdImport } from './routes/_unauth.landing.projects.$communityId'
import { Route as UnauthLandingProjectProjectIdImport } from './routes/_unauth.landing.project.$projectId'
import { Route as UnauthLandingEntityEntityIdImport } from './routes/_unauth.landing.entity.$entityId'
import { Route as UnauthLandingDiscussionDiscussionIdImport } from './routes/_unauth.landing.discussion.$discussionId'
import { Route as UnauthActivateActivateAccountCodePasswordCodeImport } from './routes/_unauth.activate.$activateAccountCode.$passwordCode'
import { Route as AuthTabEntityEntityIdDeclineInvitationImport } from './routes/_auth/tab-entity.$entityId.decline-invitation'
import { Route as AuthTabEntityEntityIdAcceptInvitationImport } from './routes/_auth/tab-entity.$entityId.accept-invitation'
import { Route as AuthProjectProjectIdOverviewImport } from './routes/_auth/project.$projectId.overview'
import { Route as AuthProjectProjectIdKpisImport } from './routes/_auth/project.$projectId.kpis'
import { Route as AuthProjectProjectIdDiscussionImport } from './routes/_auth/project.$projectId.discussion'
import { Route as AuthProjectProjectIdBusinessModelImport } from './routes/_auth/project.$projectId.business-model'
import { Route as AuthProjectEntityIdDeclineInvitationImport } from './routes/_auth/project.$entityId.decline-invitation'
import { Route as AuthProjectEntityIdAcceptInvitationImport } from './routes/_auth/project.$entityId.accept-invitation'
import { Route as AuthCommunityEntityIdDeclineInvitationImport } from './routes/_auth/community.$entityId.decline-invitation'
import { Route as AuthCommunityEntityIdAcceptInvitationImport } from './routes/_auth/community.$entityId.accept-invitation'
import { Route as AuthCommunityCommunityIdOverviewImport } from './routes/_auth/community.$communityId.overview'
import { Route as AuthCommunityCommunityIdMembersImport } from './routes/_auth/community.$communityId.members'
import { Route as AuthCommunityCommunityIdDiscussionImport } from './routes/_auth/community.$communityId.discussion'
import { Route as AuthUserUserUserIdImport } from './routes/_auth/_user/user/$userId'
import { Route as AuthUserAccountSettingsImport } from './routes/_auth/_user/account.settings'
import { Route as AuthUserAccountProfileImport } from './routes/_auth/_user/account.profile'
import { Route as AuthUserAccountNotificationImport } from './routes/_auth/_user/account.notification'
import { Route as AuthUserAccountMyStuffImport } from './routes/_auth/_user/account.my-stuff'
import { Route as AuthSuperAdminSuperAdminUsersIndexImport } from './routes/_auth/_super-admin/super-admin/users/index'
import { Route as AuthSuperAdminSuperAdminStatisticsIndexImport } from './routes/_auth/_super-admin/super-admin/statistics/index'
import { Route as AuthSuperAdminSuperAdminProjectsIndexImport } from './routes/_auth/_super-admin/super-admin/projects/index'
import { Route as AuthSuperAdminSuperAdminMethodologiesIndexImport } from './routes/_auth/_super-admin/super-admin/methodologies/index'
import { Route as AuthSuperAdminSuperAdminCommunitiesIndexImport } from './routes/_auth/_super-admin/super-admin/communities/index'
import { Route as AuthProjectProjectProjectIdIndexImport } from './routes/_auth/_project/project/$projectId/index'
import { Route as AuthCommunityCommunityCommunityIdIndexImport } from './routes/_auth/_community/community/$communityId/index'
import { Route as AuthProjectProjectIdDiscussionDiscussionIdImport } from './routes/_auth/project.$projectId.discussion.$discussionId'
import { Route as AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdImport } from './routes/_auth/application-definition/$applicationDefinitionId.application.$applicationId'
import { Route as AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdImport } from './routes/_auth/application-definition.$appDefId.evaluate-application.$applicationId'
import { Route as AuthUserAccountSettingsProviderZoomImport } from './routes/_auth/_user/account.settings.provider-zoom'
import { Route as AuthUserAccountSettingsProviderMsteamsImport } from './routes/_auth/_user/account.settings.provider-msteams'
import { Route as AuthUserAccountSettingsProviderGoogleMeetImport } from './routes/_auth/_user/account.settings.provider-google-meet'
import { Route as AuthProjectProjectProjectIdSurveysImport } from './routes/_auth/_project/project/$projectId/surveys'
import { Route as AuthProjectProjectProjectIdSettingsImport } from './routes/_auth/_project/project/$projectId/settings'
import { Route as AuthProjectProjectProjectIdResourcesImport } from './routes/_auth/_project/project/$projectId/resources'
import { Route as AuthProjectProjectProjectIdRequestsImport } from './routes/_auth/_project/project/$projectId/requests'
import { Route as AuthProjectProjectProjectIdNetworkImport } from './routes/_auth/_project/project/$projectId/network'
import { Route as AuthProjectProjectProjectIdKpisImport } from './routes/_auth/_project/project/$projectId/kpis'
import { Route as AuthProjectProjectProjectIdBusinessModelImport } from './routes/_auth/_project/project/$projectId/business-model'
import { Route as AuthCommunityCommunityCommunityIdResourcesImport } from './routes/_auth/_community/community/$communityId/resources'
import { Route as AuthCommunityCommunityCommunityIdRequestsImport } from './routes/_auth/_community/community/$communityId/requests'
import { Route as AuthCommunityCommunityCommunityIdNetworkImport } from './routes/_auth/_community/community/$communityId/network'
import { Route as AuthCommunityCommunityCommunityIdEventsImport } from './routes/_auth/_community/community/$communityId/events'
import { Route as AuthCommunityCommunityCommunityIdAboutImport } from './routes/_auth/_community/community/$communityId/about'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelImport } from './routes/_auth/_community/community/$communityId/_admin-panel'
import { Route as AuthProjectProjectProjectIdDiscussionsIndexImport } from './routes/_auth/_project/project/$projectId/discussions/index'
import { Route as AuthCommunityCommunityCommunityIdSurveysIndexImport } from './routes/_auth/_community/community/$communityId/surveys/index'
import { Route as AuthCommunityCommunityCommunityIdProjectsIndexImport } from './routes/_auth/_community/community/$communityId/projects/index'
import { Route as AuthCommunityCommunityCommunityIdDiscussionsIndexImport } from './routes/_auth/_community/community/$communityId/discussions/index'
import { Route as AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexImport } from './routes/_auth/_community/community/$communityId/application-definitions/index'
import { Route as AuthAccountNotificationsTabEntityEntityIdDeclineInvitationImport } from './routes/_auth/account.notifications.tab-entity.$entityId.decline-invitation'
import { Route as AuthAccountNotificationsTabEntityEntityIdAcceptInvitationImport } from './routes/_auth/account.notifications.tab-entity.$entityId.accept-invitation'
import { Route as AuthProjectProjectProjectIdRequestNewImport } from './routes/_auth/_project/project/$projectId/request.new'
import { Route as AuthProjectProjectProjectIdRequestRequestIdImport } from './routes/_auth/_project/project/$projectId/request.$requestId'
import { Route as AuthProjectProjectProjectIdDiscussionsNewImport } from './routes/_auth/_project/project/$projectId/discussions/new'
import { Route as AuthCommunityCommunityCommunityIdProjectCreateImport } from './routes/_auth/_community/community/$communityId/project/create'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdImport } from './routes/_auth/_community/community/$communityId/project/$projectId'
import { Route as AuthCommunityCommunityCommunityIdDiscussionsNewImport } from './routes/_auth/_community/community/$communityId/discussions/new'
import { Route as AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexImport } from './routes/_auth/_project/project/$projectId/discussions/$discussionId/index'
import { Route as AuthCommunityCommunityCommunityIdTabTabIdIndexImport } from './routes/_auth/_community/community/$communityId/tab/$tabId/index'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdIndexImport } from './routes/_auth/_community/community/$communityId/project/$projectId/index'
import { Route as AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexImport } from './routes/_auth/_community/community/$communityId/discussions/$discussionId/index'
import { Route as AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdImport } from './routes/_auth/community.$communityId.application-definition.$appDefId.evaluate.$applicationId'
import { Route as AuthProjectProjectProjectIdRequestEditRequestIdImport } from './routes/_auth/_project/project/$projectId/request.edit.$requestId'
import { Route as AuthProjectProjectProjectIdDiscussionsDiscussionIdEditImport } from './routes/_auth/_project/project/$projectId/discussions/$discussionId/edit'
import { Route as AuthCommunityCommunityCommunityIdSurveysSurveyIdViewImport } from './routes/_auth/_community/community/$communityId/surveys/$surveyId/view'
import { Route as AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesImport } from './routes/_auth/_community/community/$communityId/surveys/$surveyId/responses'
import { Route as AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteImport } from './routes/_auth/_community/community/$communityId/surveys/$surveyId.complete'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdSurveysImport } from './routes/_auth/_community/community/$communityId/project/$projectId/surveys'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdSettingsImport } from './routes/_auth/_community/community/$communityId/project/$projectId/settings'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdResourcesImport } from './routes/_auth/_community/community/$communityId/project/$projectId/resources'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdRequestsImport } from './routes/_auth/_community/community/$communityId/project/$projectId/requests'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdNetworkImport } from './routes/_auth/_community/community/$communityId/project/$projectId/network'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdKpisImport } from './routes/_auth/_community/community/$communityId/project/$projectId/kpis'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelImport } from './routes/_auth/_community/community/$communityId/project/$projectId/business-model'
import { Route as AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditImport } from './routes/_auth/_community/community/$communityId/discussions/$discussionId/edit'
import { Route as AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesImport } from './routes/_auth/_community/community/$communityId/application-definitions/$applicationId/responses'
import { Route as AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesImport } from './routes/_auth/_community/community/$communityId/application-definition-group/$groupId/responses'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexImport } from './routes/_auth/_community/community/$communityId/project/$projectId/discussions/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/users/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/index'
import { Route as AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdImport } from './routes/_auth/community.$communityId.admin-panel.application-definition.$appDefId.evaluate.$applicationId'
import { Route as AuthCommunityCommunityCommunityIdTabTabIdEntityCreateImport } from './routes/_auth/_community/community/$communityId/tab/$tabId/entity/create'
import { Route as AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdImport } from './routes/_auth/_community/community/$communityId/surveys/$surveyId.answers.$responseId'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewImport } from './routes/_auth/_community/community/$communityId/project/$projectId/request.new'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdImport } from './routes/_auth/_community/community/$communityId/project/$projectId/request.$requestId'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewImport } from './routes/_auth/_community/community/$communityId/project/$projectId/discussions/new'
import { Route as AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdImport } from './routes/_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate.$responseId'
import { Route as AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdImport } from './routes/_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create'
import { Route as AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexImport } from './routes/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/index'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexImport } from './routes/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/index'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/index'
import { Route as AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsImport } from './routes/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings'
import { Route as AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkImport } from './routes/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdImport } from './routes/_auth/_community/community/$communityId/project/$projectId/request.edit.$requestId'
import { Route as AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditImport } from './routes/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate.$responseId'
import { Route as AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdImport } from './routes/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'

// Create Virtual Routes

const AuthCommunityCommunityCommunityIdImport = createFileRoute(
  '/_auth/_community/community/$communityId',
)()

// Create/Update Routes

const SsoCallbackRoute = SsoCallbackImport.update({
  path: '/sso-callback',
  getParentRoute: () => rootRoute,
} as any)

const UnauthRoute = UnauthImport.update({
  id: '/_unauth',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const CalendarRedirectIndexRoute = CalendarRedirectIndexImport.update({
  path: '/calendar-redirect/',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const CalendarRedirectProviderZoomRoute =
  CalendarRedirectProviderZoomImport.update({
    path: '/calendar-redirect/provider-zoom',
    getParentRoute: () => rootRoute,
  } as any)

const CalendarRedirectProviderMsteamsRoute =
  CalendarRedirectProviderMsteamsImport.update({
    path: '/calendar-redirect/provider-msteams',
    getParentRoute: () => rootRoute,
  } as any)

const CalendarRedirectProviderGoogleMeetRoute =
  CalendarRedirectProviderGoogleMeetImport.update({
    path: '/calendar-redirect/provider-google-meet',
    getParentRoute: () => rootRoute,
  } as any)

const ApplicationDefinitionApplicationDefinitionIdRoute =
  ApplicationDefinitionApplicationDefinitionIdImport.update({
    path: '/application-definition/$applicationDefinitionId',
    getParentRoute: () => rootRoute,
  } as any)

const UnauthSignupRoute = UnauthSignupImport.update({
  path: '/signup',
  getParentRoute: () => UnauthRoute,
} as any)

const UnauthLoginRoute = UnauthLoginImport.update({
  path: '/login',
  getParentRoute: () => UnauthRoute,
} as any)

const UnauthLandingRoute = UnauthLandingImport.update({
  path: '/landing',
  getParentRoute: () => UnauthRoute,
} as any)

const UnauthForgotPasswordRoute = UnauthForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => UnauthRoute,
} as any)

const AuthApplicationDefinitionRoute = AuthApplicationDefinitionImport.update({
  path: '/application-definition',
  getParentRoute: () => AuthRoute,
} as any)

const AuthUserRoute = AuthUserImport.update({
  id: '/_user',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSuperAdminRoute = AuthSuperAdminImport.update({
  id: '/_super-admin',
  getParentRoute: () => AuthRoute,
} as any)

const AuthProjectRoute = AuthProjectImport.update({
  id: '/_project',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCommunityRoute = AuthCommunityImport.update({
  id: '/_community',
  getParentRoute: () => AuthRoute,
} as any)

const UnauthLandingIndexRoute = UnauthLandingIndexImport.update({
  path: '/',
  getParentRoute: () => UnauthLandingRoute,
} as any)

const UnauthResetPasswordActivationCodeRoute =
  UnauthResetPasswordActivationCodeImport.update({
    path: '/reset-password/$activationCode',
    getParentRoute: () => UnauthRoute,
  } as any)

const UnauthActivateCodeRoute = UnauthActivateCodeImport.update({
  path: '/activate/$code',
  getParentRoute: () => UnauthRoute,
} as any)

const AuthRequestDeclineInvitationRoute =
  AuthRequestDeclineInvitationImport.update({
    path: '/request/decline-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthRequestAcceptInvitationRoute =
  AuthRequestAcceptInvitationImport.update({
    path: '/request/accept-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProjectProjectIdRoute = AuthProjectProjectIdImport.update({
  path: '/project/$projectId',
  getParentRoute: () => AuthRoute,
} as any)

const AuthUserEditProfileRoute = AuthUserEditProfileImport.update({
  path: '/edit-profile',
  getParentRoute: () => AuthUserRoute,
} as any)

const AuthCommunityCommunityCommunityIdRoute =
  AuthCommunityCommunityCommunityIdImport.update({
    path: '/community/$communityId',
    getParentRoute: () => AuthCommunityRoute,
  } as any)

const EventsPublicJoinTokenRoute = EventsPublicJoinTokenImport.update({
  path: '/events/public/join/$token',
  getParentRoute: () => rootRoute,
} as any)

const ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute =
  ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationImport.update(
    {
      path: '/application/new-application',
      getParentRoute: () => ApplicationDefinitionApplicationDefinitionIdRoute,
    } as any,
  )

const ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute =
  ApplicationDefinitionApplicationDefinitionIdApplicationCreateImport.update({
    path: '/application/create',
    getParentRoute: () => ApplicationDefinitionApplicationDefinitionIdRoute,
  } as any)

const ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute =
  ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdImport.update(
    {
      path: '/application/$applicationId',
      getParentRoute: () => ApplicationDefinitionApplicationDefinitionIdRoute,
    } as any,
  )

const UnauthLandingTabTabIdRoute = UnauthLandingTabTabIdImport.update({
  path: '/tab/$tabId',
  getParentRoute: () => UnauthLandingRoute,
} as any)

const UnauthLandingRequestRequestIdRoute =
  UnauthLandingRequestRequestIdImport.update({
    path: '/request/$requestId',
    getParentRoute: () => UnauthLandingRoute,
  } as any)

const UnauthLandingProjectsCommunityIdRoute =
  UnauthLandingProjectsCommunityIdImport.update({
    path: '/projects/$communityId',
    getParentRoute: () => UnauthLandingRoute,
  } as any)

const UnauthLandingProjectProjectIdRoute =
  UnauthLandingProjectProjectIdImport.update({
    path: '/project/$projectId',
    getParentRoute: () => UnauthLandingRoute,
  } as any)

const UnauthLandingEntityEntityIdRoute =
  UnauthLandingEntityEntityIdImport.update({
    path: '/entity/$entityId',
    getParentRoute: () => UnauthLandingRoute,
  } as any)

const UnauthLandingDiscussionDiscussionIdRoute =
  UnauthLandingDiscussionDiscussionIdImport.update({
    path: '/discussion/$discussionId',
    getParentRoute: () => UnauthLandingRoute,
  } as any)

const UnauthActivateActivateAccountCodePasswordCodeRoute =
  UnauthActivateActivateAccountCodePasswordCodeImport.update({
    path: '/activate/$activateAccountCode/$passwordCode',
    getParentRoute: () => UnauthRoute,
  } as any)

const AuthTabEntityEntityIdDeclineInvitationRoute =
  AuthTabEntityEntityIdDeclineInvitationImport.update({
    path: '/tab-entity/$entityId/decline-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthTabEntityEntityIdAcceptInvitationRoute =
  AuthTabEntityEntityIdAcceptInvitationImport.update({
    path: '/tab-entity/$entityId/accept-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProjectProjectIdOverviewRoute =
  AuthProjectProjectIdOverviewImport.update({
    path: '/overview',
    getParentRoute: () => AuthProjectProjectIdRoute,
  } as any)

const AuthProjectProjectIdKpisRoute = AuthProjectProjectIdKpisImport.update({
  path: '/kpis',
  getParentRoute: () => AuthProjectProjectIdRoute,
} as any)

const AuthProjectProjectIdDiscussionRoute =
  AuthProjectProjectIdDiscussionImport.update({
    path: '/discussion',
    getParentRoute: () => AuthProjectProjectIdRoute,
  } as any)

const AuthProjectProjectIdBusinessModelRoute =
  AuthProjectProjectIdBusinessModelImport.update({
    path: '/business-model',
    getParentRoute: () => AuthProjectProjectIdRoute,
  } as any)

const AuthProjectEntityIdDeclineInvitationRoute =
  AuthProjectEntityIdDeclineInvitationImport.update({
    path: '/project/$entityId/decline-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProjectEntityIdAcceptInvitationRoute =
  AuthProjectEntityIdAcceptInvitationImport.update({
    path: '/project/$entityId/accept-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthCommunityEntityIdDeclineInvitationRoute =
  AuthCommunityEntityIdDeclineInvitationImport.update({
    path: '/community/$entityId/decline-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthCommunityEntityIdAcceptInvitationRoute =
  AuthCommunityEntityIdAcceptInvitationImport.update({
    path: '/community/$entityId/accept-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthCommunityCommunityIdOverviewRoute =
  AuthCommunityCommunityIdOverviewImport.update({
    path: '/community/$communityId/overview',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthCommunityCommunityIdMembersRoute =
  AuthCommunityCommunityIdMembersImport.update({
    path: '/community/$communityId/members',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthCommunityCommunityIdDiscussionRoute =
  AuthCommunityCommunityIdDiscussionImport.update({
    path: '/community/$communityId/discussion',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthUserUserUserIdRoute = AuthUserUserUserIdImport.update({
  path: '/user/$userId',
  getParentRoute: () => AuthUserRoute,
} as any)

const AuthUserAccountSettingsRoute = AuthUserAccountSettingsImport.update({
  path: '/account/settings',
  getParentRoute: () => AuthUserRoute,
} as any)

const AuthUserAccountProfileRoute = AuthUserAccountProfileImport.update({
  path: '/account/profile',
  getParentRoute: () => AuthUserRoute,
} as any)

const AuthUserAccountNotificationRoute =
  AuthUserAccountNotificationImport.update({
    path: '/account/notification',
    getParentRoute: () => AuthUserRoute,
  } as any)

const AuthUserAccountMyStuffRoute = AuthUserAccountMyStuffImport.update({
  path: '/account/my-stuff',
  getParentRoute: () => AuthUserRoute,
} as any)

const AuthSuperAdminSuperAdminUsersIndexRoute =
  AuthSuperAdminSuperAdminUsersIndexImport.update({
    path: '/super-admin/users/',
    getParentRoute: () => AuthSuperAdminRoute,
  } as any)

const AuthSuperAdminSuperAdminStatisticsIndexRoute =
  AuthSuperAdminSuperAdminStatisticsIndexImport.update({
    path: '/super-admin/statistics/',
    getParentRoute: () => AuthSuperAdminRoute,
  } as any)

const AuthSuperAdminSuperAdminProjectsIndexRoute =
  AuthSuperAdminSuperAdminProjectsIndexImport.update({
    path: '/super-admin/projects/',
    getParentRoute: () => AuthSuperAdminRoute,
  } as any)

const AuthSuperAdminSuperAdminMethodologiesIndexRoute =
  AuthSuperAdminSuperAdminMethodologiesIndexImport.update({
    path: '/super-admin/methodologies/',
    getParentRoute: () => AuthSuperAdminRoute,
  } as any)

const AuthSuperAdminSuperAdminCommunitiesIndexRoute =
  AuthSuperAdminSuperAdminCommunitiesIndexImport.update({
    path: '/super-admin/communities/',
    getParentRoute: () => AuthSuperAdminRoute,
  } as any)

const AuthProjectProjectProjectIdIndexRoute =
  AuthProjectProjectProjectIdIndexImport.update({
    path: '/project/$projectId/',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthCommunityCommunityCommunityIdIndexRoute =
  AuthCommunityCommunityCommunityIdIndexImport.update({
    path: '/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthProjectProjectIdDiscussionDiscussionIdRoute =
  AuthProjectProjectIdDiscussionDiscussionIdImport.update({
    path: '/$discussionId',
    getParentRoute: () => AuthProjectProjectIdDiscussionRoute,
  } as any)

const AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute =
  AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdImport.update(
    {
      path: '/$applicationDefinitionId/application/$applicationId',
      getParentRoute: () => AuthApplicationDefinitionRoute,
    } as any,
  )

const AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute =
  AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdImport.update(
    {
      path: '/$appDefId/evaluate-application/$applicationId',
      getParentRoute: () => AuthApplicationDefinitionRoute,
    } as any,
  )

const AuthUserAccountSettingsProviderZoomRoute =
  AuthUserAccountSettingsProviderZoomImport.update({
    path: '/provider-zoom',
    getParentRoute: () => AuthUserAccountSettingsRoute,
  } as any)

const AuthUserAccountSettingsProviderMsteamsRoute =
  AuthUserAccountSettingsProviderMsteamsImport.update({
    path: '/provider-msteams',
    getParentRoute: () => AuthUserAccountSettingsRoute,
  } as any)

const AuthUserAccountSettingsProviderGoogleMeetRoute =
  AuthUserAccountSettingsProviderGoogleMeetImport.update({
    path: '/provider-google-meet',
    getParentRoute: () => AuthUserAccountSettingsRoute,
  } as any)

const AuthProjectProjectProjectIdSurveysRoute =
  AuthProjectProjectProjectIdSurveysImport.update({
    path: '/project/$projectId/surveys',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdSettingsRoute =
  AuthProjectProjectProjectIdSettingsImport.update({
    path: '/project/$projectId/settings',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdResourcesRoute =
  AuthProjectProjectProjectIdResourcesImport.update({
    path: '/project/$projectId/resources',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdRequestsRoute =
  AuthProjectProjectProjectIdRequestsImport.update({
    path: '/project/$projectId/requests',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdNetworkRoute =
  AuthProjectProjectProjectIdNetworkImport.update({
    path: '/project/$projectId/network',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdKpisRoute =
  AuthProjectProjectProjectIdKpisImport.update({
    path: '/project/$projectId/kpis',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdBusinessModelRoute =
  AuthProjectProjectProjectIdBusinessModelImport.update({
    path: '/project/$projectId/business-model',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthCommunityCommunityCommunityIdResourcesRoute =
  AuthCommunityCommunityCommunityIdResourcesImport.update({
    path: '/resources',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdRequestsRoute =
  AuthCommunityCommunityCommunityIdRequestsImport.update({
    path: '/requests',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdNetworkRoute =
  AuthCommunityCommunityCommunityIdNetworkImport.update({
    path: '/network',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdEventsRoute =
  AuthCommunityCommunityCommunityIdEventsImport.update({
    path: '/events',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdAboutRoute =
  AuthCommunityCommunityCommunityIdAboutImport.update({
    path: '/about',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdAdminPanelRoute =
  AuthCommunityCommunityCommunityIdAdminPanelImport.update({
    id: '/_admin-panel',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthProjectProjectProjectIdDiscussionsIndexRoute =
  AuthProjectProjectProjectIdDiscussionsIndexImport.update({
    path: '/project/$projectId/discussions/',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthCommunityCommunityCommunityIdSurveysIndexRoute =
  AuthCommunityCommunityCommunityIdSurveysIndexImport.update({
    path: '/surveys/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectsIndexRoute =
  AuthCommunityCommunityCommunityIdProjectsIndexImport.update({
    path: '/projects/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdDiscussionsIndexRoute =
  AuthCommunityCommunityCommunityIdDiscussionsIndexImport.update({
    path: '/discussions/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute =
  AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexImport.update({
    path: '/application-definitions/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute =
  AuthAccountNotificationsTabEntityEntityIdDeclineInvitationImport.update({
    path: '/account/notifications/tab-entity/$entityId/decline-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute =
  AuthAccountNotificationsTabEntityEntityIdAcceptInvitationImport.update({
    path: '/account/notifications/tab-entity/$entityId/accept-invitation',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthProjectProjectProjectIdRequestNewRoute =
  AuthProjectProjectProjectIdRequestNewImport.update({
    path: '/project/$projectId/request/new',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdRequestRequestIdRoute =
  AuthProjectProjectProjectIdRequestRequestIdImport.update({
    path: '/project/$projectId/request/$requestId',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdDiscussionsNewRoute =
  AuthProjectProjectProjectIdDiscussionsNewImport.update({
    path: '/project/$projectId/discussions/new',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectCreateRoute =
  AuthCommunityCommunityCommunityIdProjectCreateImport.update({
    path: '/project/create',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdImport.update({
    path: '/project/$projectId',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdDiscussionsNewRoute =
  AuthCommunityCommunityCommunityIdDiscussionsNewImport.update({
    path: '/discussions/new',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute =
  AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexImport.update({
    path: '/project/$projectId/discussions/$discussionId/',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthCommunityCommunityCommunityIdTabTabIdIndexRoute =
  AuthCommunityCommunityCommunityIdTabTabIdIndexImport.update({
    path: '/tab/$tabId/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdIndexImport.update({
    path: '/',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute =
  AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexImport.update({
    path: '/discussions/$discussionId/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute =
  AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdImport.update(
    {
      path: '/community/$communityId/application-definition/$appDefId/evaluate/$applicationId',
      getParentRoute: () => AuthRoute,
    } as any,
  )

const AuthProjectProjectProjectIdRequestEditRequestIdRoute =
  AuthProjectProjectProjectIdRequestEditRequestIdImport.update({
    path: '/project/$projectId/request/edit/$requestId',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute =
  AuthProjectProjectProjectIdDiscussionsDiscussionIdEditImport.update({
    path: '/project/$projectId/discussions/$discussionId/edit',
    getParentRoute: () => AuthProjectRoute,
  } as any)

const AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute =
  AuthCommunityCommunityCommunityIdSurveysSurveyIdViewImport.update({
    path: '/surveys/$surveyId/view',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute =
  AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesImport.update({
    path: '/surveys/$surveyId/responses',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute =
  AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteImport.update({
    path: '/surveys/$surveyId/complete',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdSurveysImport.update({
    path: '/surveys',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdSettingsImport.update({
    path: '/settings',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdResourcesImport.update({
    path: '/resources',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestsImport.update({
    path: '/requests',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdNetworkImport.update({
    path: '/network',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdKpisImport.update({
    path: '/kpis',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelImport.update({
    path: '/business-model',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute =
  AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditImport.update({
    path: '/discussions/$discussionId/edit',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute =
  AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesImport.update(
    {
      path: '/application-definitions/$applicationId/responses',
      getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute =
  AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesImport.update(
    {
      path: '/application-definition-group/$groupId/responses',
      getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsImport.update(
    {
      path: '/admin-panel/event-settings',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsImport.update(
    {
      path: '/admin-panel/community-settings',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexImport.update(
    {
      path: '/discussions/',
      getParentRoute: () =>
        AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexImport.update({
    path: '/admin-panel/users/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
  } as any)

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexImport.update(
    {
      path: '/admin-panel/surveys/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexImport.update(
    {
      path: '/admin-panel/statistics/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexImport.update(
    {
      path: '/admin-panel/startups-progress/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexImport.update(
    {
      path: '/admin-panel/startup-kpis/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexImport.update(
    {
      path: '/admin-panel/requests-status/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexImport.update(
    {
      path: '/admin-panel/programs/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexImport.update({
    path: '/admin-panel/pages/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
  } as any)

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexImport.update(
    {
      path: '/admin-panel/overview-projects/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexImport.update(
    {
      path: '/admin-panel/circle-management/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexImport.update(
    {
      path: '/admin-panel/application-definitions/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexImport.update(
    {
      path: '/admin-panel/activity-feed/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute =
  AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdImport.update(
    {
      path: '/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId',
      getParentRoute: () => AuthRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute =
  AuthCommunityCommunityCommunityIdTabTabIdEntityCreateImport.update({
    path: '/tab/$tabId/entity/create',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute =
  AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdImport.update(
    {
      path: '/surveys/$surveyId/answers/$responseId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewImport.update({
    path: '/request/new',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdImport.update(
    {
      path: '/request/$requestId',
      getParentRoute: () =>
        AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewImport.update({
    path: '/discussions/new',
    getParentRoute: () =>
      AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute =
  AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdImport.update(
    {
      path: '/application-definitions/$applicationId/evaluate/$responseId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute =
  AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdImport.update(
    {
      path: '/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateImport.update(
    {
      path: '/admin-panel/surveys/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateImport.update(
    {
      path: '/admin-panel/programs/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateImport.update(
    {
      path: '/admin-panel/pages/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateImport.update(
    {
      path: '/admin-panel/application-definitions/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute =
  AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexImport.update({
    path: '/tab/$tabId/entity/$entityId/',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexImport.update(
    {
      path: '/discussions/$discussionId/',
      getParentRoute: () =>
        AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexImport.update(
    {
      path: '/admin-panel/surveys/$surveyId/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexImport.update(
    {
      path: '/admin-panel/programs/$programId/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexImport.update(
    {
      path: '/admin-panel/pages/$pageId/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexImport.update(
    {
      path: '/admin-panel/forms/survey/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexImport.update(
    {
      path: '/admin-panel/forms/methodology/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexImport.update(
    {
      path: '/admin-panel/forms/evaluation/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexImport.update(
    {
      path: '/admin-panel/forms/application/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexImport.update(
    {
      path: '/admin-panel/application-definitions/$applicationId/',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute =
  AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsImport.update({
    path: '/tab/$tabId/entity/$entityId/settings',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute =
  AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkImport.update({
    path: '/tab/$tabId/entity/$entityId/network',
    getParentRoute: () => AuthCommunityCommunityCommunityIdRoute,
  } as any)

const AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdImport.update(
    {
      path: '/request/edit/$requestId',
      getParentRoute: () =>
        AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute =
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditImport.update(
    {
      path: '/discussions/$discussionId/edit',
      getParentRoute: () =>
        AuthCommunityCommunityCommunityIdProjectProjectIdRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewImport.update(
    {
      path: '/admin-panel/surveys/$surveyId/view',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesImport.update(
    {
      path: '/admin-panel/surveys/$surveyId/responses',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewImport.update(
    {
      path: '/admin-panel/surveys/$surveyId/preview',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerImport.update(
    {
      path: '/admin-panel/programs/$programId/planner',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleImport.update(
    {
      path: '/admin-panel/programs/$programId/people',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisImport.update(
    {
      path: '/admin-panel/programs/$programId/kpis',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateImport.update(
    {
      path: '/admin-panel/forms/survey/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdImport.update(
    {
      path: '/admin-panel/forms/survey/$formId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateImport.update(
    {
      path: '/admin-panel/forms/methodology/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdImport.update(
    {
      path: '/admin-panel/forms/methodology/$formId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateImport.update(
    {
      path: '/admin-panel/forms/evaluation/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdImport.update(
    {
      path: '/admin-panel/forms/evaluation/$formId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateImport.update(
    {
      path: '/admin-panel/forms/application/create',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdImport.update(
    {
      path: '/admin-panel/forms/application/$formId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesImport.update(
    {
      path: '/admin-panel/application-definitions/$applicationId/responses',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesImport.update(
    {
      path: '/admin-panel/application-definition-group/$groupId/responses',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdImport.update(
    {
      path: '/admin-panel/application-definitions/$applicationId/evaluate/$responseId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

const AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute =
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdImport.update(
    {
      path: '/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId',
      getParentRoute: () => AuthCommunityCommunityCommunityIdAdminPanelRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_unauth': {
      id: '/_unauth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthImport
      parentRoute: typeof rootRoute
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_community': {
      id: '/_auth/_community'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthCommunityImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_project': {
      id: '/_auth/_project'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthProjectImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_super-admin': {
      id: '/_auth/_super-admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthSuperAdminImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_user': {
      id: '/_auth/_user'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthUserImport
      parentRoute: typeof AuthImport
    }
    '/_auth/application-definition': {
      id: '/_auth/application-definition'
      path: '/application-definition'
      fullPath: '/application-definition'
      preLoaderRoute: typeof AuthApplicationDefinitionImport
      parentRoute: typeof AuthImport
    }
    '/_unauth/forgot-password': {
      id: '/_unauth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthForgotPasswordImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/landing': {
      id: '/_unauth/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof UnauthLandingImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/login': {
      id: '/_unauth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthLoginImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/signup': {
      id: '/_unauth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof UnauthSignupImport
      parentRoute: typeof UnauthImport
    }
    '/application-definition/$applicationDefinitionId': {
      id: '/application-definition/$applicationDefinitionId'
      path: '/application-definition/$applicationDefinitionId'
      fullPath: '/application-definition/$applicationDefinitionId'
      preLoaderRoute: typeof ApplicationDefinitionApplicationDefinitionIdImport
      parentRoute: typeof rootRoute
    }
    '/calendar-redirect/provider-google-meet': {
      id: '/calendar-redirect/provider-google-meet'
      path: '/calendar-redirect/provider-google-meet'
      fullPath: '/calendar-redirect/provider-google-meet'
      preLoaderRoute: typeof CalendarRedirectProviderGoogleMeetImport
      parentRoute: typeof rootRoute
    }
    '/calendar-redirect/provider-msteams': {
      id: '/calendar-redirect/provider-msteams'
      path: '/calendar-redirect/provider-msteams'
      fullPath: '/calendar-redirect/provider-msteams'
      preLoaderRoute: typeof CalendarRedirectProviderMsteamsImport
      parentRoute: typeof rootRoute
    }
    '/calendar-redirect/provider-zoom': {
      id: '/calendar-redirect/provider-zoom'
      path: '/calendar-redirect/provider-zoom'
      fullPath: '/calendar-redirect/provider-zoom'
      preLoaderRoute: typeof CalendarRedirectProviderZoomImport
      parentRoute: typeof rootRoute
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/calendar-redirect/': {
      id: '/calendar-redirect/'
      path: '/calendar-redirect'
      fullPath: '/calendar-redirect'
      preLoaderRoute: typeof CalendarRedirectIndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_user/edit-profile': {
      id: '/_auth/_user/edit-profile'
      path: '/edit-profile'
      fullPath: '/edit-profile'
      preLoaderRoute: typeof AuthUserEditProfileImport
      parentRoute: typeof AuthUserImport
    }
    '/_auth/project/$projectId': {
      id: '/_auth/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof AuthProjectProjectIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/request/accept-invitation': {
      id: '/_auth/request/accept-invitation'
      path: '/request/accept-invitation'
      fullPath: '/request/accept-invitation'
      preLoaderRoute: typeof AuthRequestAcceptInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/request/decline-invitation': {
      id: '/_auth/request/decline-invitation'
      path: '/request/decline-invitation'
      fullPath: '/request/decline-invitation'
      preLoaderRoute: typeof AuthRequestDeclineInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_unauth/activate/$code': {
      id: '/_unauth/activate/$code'
      path: '/activate/$code'
      fullPath: '/activate/$code'
      preLoaderRoute: typeof UnauthActivateCodeImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/reset-password/$activationCode': {
      id: '/_unauth/reset-password/$activationCode'
      path: '/reset-password/$activationCode'
      fullPath: '/reset-password/$activationCode'
      preLoaderRoute: typeof UnauthResetPasswordActivationCodeImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/landing/': {
      id: '/_unauth/landing/'
      path: '/'
      fullPath: '/landing/'
      preLoaderRoute: typeof UnauthLandingIndexImport
      parentRoute: typeof UnauthLandingImport
    }
    '/_auth/_user/account/my-stuff': {
      id: '/_auth/_user/account/my-stuff'
      path: '/account/my-stuff'
      fullPath: '/account/my-stuff'
      preLoaderRoute: typeof AuthUserAccountMyStuffImport
      parentRoute: typeof AuthUserImport
    }
    '/_auth/_user/account/notification': {
      id: '/_auth/_user/account/notification'
      path: '/account/notification'
      fullPath: '/account/notification'
      preLoaderRoute: typeof AuthUserAccountNotificationImport
      parentRoute: typeof AuthUserImport
    }
    '/_auth/_user/account/profile': {
      id: '/_auth/_user/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AuthUserAccountProfileImport
      parentRoute: typeof AuthUserImport
    }
    '/_auth/_user/account/settings': {
      id: '/_auth/_user/account/settings'
      path: '/account/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AuthUserAccountSettingsImport
      parentRoute: typeof AuthUserImport
    }
    '/_auth/_user/user/$userId': {
      id: '/_auth/_user/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof AuthUserUserUserIdImport
      parentRoute: typeof AuthUserImport
    }
    '/_auth/community/$communityId/discussion': {
      id: '/_auth/community/$communityId/discussion'
      path: '/community/$communityId/discussion'
      fullPath: '/community/$communityId/discussion'
      preLoaderRoute: typeof AuthCommunityCommunityIdDiscussionImport
      parentRoute: typeof AuthImport
    }
    '/_auth/community/$communityId/members': {
      id: '/_auth/community/$communityId/members'
      path: '/community/$communityId/members'
      fullPath: '/community/$communityId/members'
      preLoaderRoute: typeof AuthCommunityCommunityIdMembersImport
      parentRoute: typeof AuthImport
    }
    '/_auth/community/$communityId/overview': {
      id: '/_auth/community/$communityId/overview'
      path: '/community/$communityId/overview'
      fullPath: '/community/$communityId/overview'
      preLoaderRoute: typeof AuthCommunityCommunityIdOverviewImport
      parentRoute: typeof AuthImport
    }
    '/_auth/community/$entityId/accept-invitation': {
      id: '/_auth/community/$entityId/accept-invitation'
      path: '/community/$entityId/accept-invitation'
      fullPath: '/community/$entityId/accept-invitation'
      preLoaderRoute: typeof AuthCommunityEntityIdAcceptInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/community/$entityId/decline-invitation': {
      id: '/_auth/community/$entityId/decline-invitation'
      path: '/community/$entityId/decline-invitation'
      fullPath: '/community/$entityId/decline-invitation'
      preLoaderRoute: typeof AuthCommunityEntityIdDeclineInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/project/$entityId/accept-invitation': {
      id: '/_auth/project/$entityId/accept-invitation'
      path: '/project/$entityId/accept-invitation'
      fullPath: '/project/$entityId/accept-invitation'
      preLoaderRoute: typeof AuthProjectEntityIdAcceptInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/project/$entityId/decline-invitation': {
      id: '/_auth/project/$entityId/decline-invitation'
      path: '/project/$entityId/decline-invitation'
      fullPath: '/project/$entityId/decline-invitation'
      preLoaderRoute: typeof AuthProjectEntityIdDeclineInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/project/$projectId/business-model': {
      id: '/_auth/project/$projectId/business-model'
      path: '/business-model'
      fullPath: '/project/$projectId/business-model'
      preLoaderRoute: typeof AuthProjectProjectIdBusinessModelImport
      parentRoute: typeof AuthProjectProjectIdImport
    }
    '/_auth/project/$projectId/discussion': {
      id: '/_auth/project/$projectId/discussion'
      path: '/discussion'
      fullPath: '/project/$projectId/discussion'
      preLoaderRoute: typeof AuthProjectProjectIdDiscussionImport
      parentRoute: typeof AuthProjectProjectIdImport
    }
    '/_auth/project/$projectId/kpis': {
      id: '/_auth/project/$projectId/kpis'
      path: '/kpis'
      fullPath: '/project/$projectId/kpis'
      preLoaderRoute: typeof AuthProjectProjectIdKpisImport
      parentRoute: typeof AuthProjectProjectIdImport
    }
    '/_auth/project/$projectId/overview': {
      id: '/_auth/project/$projectId/overview'
      path: '/overview'
      fullPath: '/project/$projectId/overview'
      preLoaderRoute: typeof AuthProjectProjectIdOverviewImport
      parentRoute: typeof AuthProjectProjectIdImport
    }
    '/_auth/tab-entity/$entityId/accept-invitation': {
      id: '/_auth/tab-entity/$entityId/accept-invitation'
      path: '/tab-entity/$entityId/accept-invitation'
      fullPath: '/tab-entity/$entityId/accept-invitation'
      preLoaderRoute: typeof AuthTabEntityEntityIdAcceptInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/tab-entity/$entityId/decline-invitation': {
      id: '/_auth/tab-entity/$entityId/decline-invitation'
      path: '/tab-entity/$entityId/decline-invitation'
      fullPath: '/tab-entity/$entityId/decline-invitation'
      preLoaderRoute: typeof AuthTabEntityEntityIdDeclineInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_unauth/activate/$activateAccountCode/$passwordCode': {
      id: '/_unauth/activate/$activateAccountCode/$passwordCode'
      path: '/activate/$activateAccountCode/$passwordCode'
      fullPath: '/activate/$activateAccountCode/$passwordCode'
      preLoaderRoute: typeof UnauthActivateActivateAccountCodePasswordCodeImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/landing/discussion/$discussionId': {
      id: '/_unauth/landing/discussion/$discussionId'
      path: '/discussion/$discussionId'
      fullPath: '/landing/discussion/$discussionId'
      preLoaderRoute: typeof UnauthLandingDiscussionDiscussionIdImport
      parentRoute: typeof UnauthLandingImport
    }
    '/_unauth/landing/entity/$entityId': {
      id: '/_unauth/landing/entity/$entityId'
      path: '/entity/$entityId'
      fullPath: '/landing/entity/$entityId'
      preLoaderRoute: typeof UnauthLandingEntityEntityIdImport
      parentRoute: typeof UnauthLandingImport
    }
    '/_unauth/landing/project/$projectId': {
      id: '/_unauth/landing/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/landing/project/$projectId'
      preLoaderRoute: typeof UnauthLandingProjectProjectIdImport
      parentRoute: typeof UnauthLandingImport
    }
    '/_unauth/landing/projects/$communityId': {
      id: '/_unauth/landing/projects/$communityId'
      path: '/projects/$communityId'
      fullPath: '/landing/projects/$communityId'
      preLoaderRoute: typeof UnauthLandingProjectsCommunityIdImport
      parentRoute: typeof UnauthLandingImport
    }
    '/_unauth/landing/request/$requestId': {
      id: '/_unauth/landing/request/$requestId'
      path: '/request/$requestId'
      fullPath: '/landing/request/$requestId'
      preLoaderRoute: typeof UnauthLandingRequestRequestIdImport
      parentRoute: typeof UnauthLandingImport
    }
    '/_unauth/landing/tab/$tabId': {
      id: '/_unauth/landing/tab/$tabId'
      path: '/tab/$tabId'
      fullPath: '/landing/tab/$tabId'
      preLoaderRoute: typeof UnauthLandingTabTabIdImport
      parentRoute: typeof UnauthLandingImport
    }
    '/application-definition/$applicationDefinitionId/application/$applicationId': {
      id: '/application-definition/$applicationDefinitionId/application/$applicationId'
      path: '/application/$applicationId'
      fullPath: '/application-definition/$applicationDefinitionId/application/$applicationId'
      preLoaderRoute: typeof ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdImport
      parentRoute: typeof ApplicationDefinitionApplicationDefinitionIdImport
    }
    '/application-definition/$applicationDefinitionId/application/create': {
      id: '/application-definition/$applicationDefinitionId/application/create'
      path: '/application/create'
      fullPath: '/application-definition/$applicationDefinitionId/application/create'
      preLoaderRoute: typeof ApplicationDefinitionApplicationDefinitionIdApplicationCreateImport
      parentRoute: typeof ApplicationDefinitionApplicationDefinitionIdImport
    }
    '/application-definition/$applicationDefinitionId/application/new-application': {
      id: '/application-definition/$applicationDefinitionId/application/new-application'
      path: '/application/new-application'
      fullPath: '/application-definition/$applicationDefinitionId/application/new-application'
      preLoaderRoute: typeof ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationImport
      parentRoute: typeof ApplicationDefinitionApplicationDefinitionIdImport
    }
    '/events/public/join/$token': {
      id: '/events/public/join/$token'
      path: '/events/public/join/$token'
      fullPath: '/events/public/join/$token'
      preLoaderRoute: typeof EventsPublicJoinTokenImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_community/community/$communityId': {
      id: '/_auth/_community/community/$communityId'
      path: '/community/$communityId'
      fullPath: '/community/$communityId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdImport
      parentRoute: typeof AuthCommunityImport
    }
    '/_auth/_community/community/$communityId/_admin-panel': {
      id: '/_auth/_community/community/$communityId/_admin-panel'
      path: '/community/$communityId'
      fullPath: '/community/$communityId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdRoute
    }
    '/_auth/_community/community/$communityId/about': {
      id: '/_auth/_community/community/$communityId/about'
      path: '/about'
      fullPath: '/community/$communityId/about'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAboutImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/events': {
      id: '/_auth/_community/community/$communityId/events'
      path: '/events'
      fullPath: '/community/$communityId/events'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdEventsImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/network': {
      id: '/_auth/_community/community/$communityId/network'
      path: '/network'
      fullPath: '/community/$communityId/network'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdNetworkImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/requests': {
      id: '/_auth/_community/community/$communityId/requests'
      path: '/requests'
      fullPath: '/community/$communityId/requests'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdRequestsImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/resources': {
      id: '/_auth/_community/community/$communityId/resources'
      path: '/resources'
      fullPath: '/community/$communityId/resources'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdResourcesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_project/project/$projectId/business-model': {
      id: '/_auth/_project/project/$projectId/business-model'
      path: '/project/$projectId/business-model'
      fullPath: '/project/$projectId/business-model'
      preLoaderRoute: typeof AuthProjectProjectProjectIdBusinessModelImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/kpis': {
      id: '/_auth/_project/project/$projectId/kpis'
      path: '/project/$projectId/kpis'
      fullPath: '/project/$projectId/kpis'
      preLoaderRoute: typeof AuthProjectProjectProjectIdKpisImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/network': {
      id: '/_auth/_project/project/$projectId/network'
      path: '/project/$projectId/network'
      fullPath: '/project/$projectId/network'
      preLoaderRoute: typeof AuthProjectProjectProjectIdNetworkImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/requests': {
      id: '/_auth/_project/project/$projectId/requests'
      path: '/project/$projectId/requests'
      fullPath: '/project/$projectId/requests'
      preLoaderRoute: typeof AuthProjectProjectProjectIdRequestsImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/resources': {
      id: '/_auth/_project/project/$projectId/resources'
      path: '/project/$projectId/resources'
      fullPath: '/project/$projectId/resources'
      preLoaderRoute: typeof AuthProjectProjectProjectIdResourcesImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/settings': {
      id: '/_auth/_project/project/$projectId/settings'
      path: '/project/$projectId/settings'
      fullPath: '/project/$projectId/settings'
      preLoaderRoute: typeof AuthProjectProjectProjectIdSettingsImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/surveys': {
      id: '/_auth/_project/project/$projectId/surveys'
      path: '/project/$projectId/surveys'
      fullPath: '/project/$projectId/surveys'
      preLoaderRoute: typeof AuthProjectProjectProjectIdSurveysImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_user/account/settings/provider-google-meet': {
      id: '/_auth/_user/account/settings/provider-google-meet'
      path: '/provider-google-meet'
      fullPath: '/account/settings/provider-google-meet'
      preLoaderRoute: typeof AuthUserAccountSettingsProviderGoogleMeetImport
      parentRoute: typeof AuthUserAccountSettingsImport
    }
    '/_auth/_user/account/settings/provider-msteams': {
      id: '/_auth/_user/account/settings/provider-msteams'
      path: '/provider-msteams'
      fullPath: '/account/settings/provider-msteams'
      preLoaderRoute: typeof AuthUserAccountSettingsProviderMsteamsImport
      parentRoute: typeof AuthUserAccountSettingsImport
    }
    '/_auth/_user/account/settings/provider-zoom': {
      id: '/_auth/_user/account/settings/provider-zoom'
      path: '/provider-zoom'
      fullPath: '/account/settings/provider-zoom'
      preLoaderRoute: typeof AuthUserAccountSettingsProviderZoomImport
      parentRoute: typeof AuthUserAccountSettingsImport
    }
    '/_auth/application-definition/$appDefId/evaluate-application/$applicationId': {
      id: '/_auth/application-definition/$appDefId/evaluate-application/$applicationId'
      path: '/$appDefId/evaluate-application/$applicationId'
      fullPath: '/application-definition/$appDefId/evaluate-application/$applicationId'
      preLoaderRoute: typeof AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdImport
      parentRoute: typeof AuthApplicationDefinitionImport
    }
    '/_auth/application-definition/$applicationDefinitionId/application/$applicationId': {
      id: '/_auth/application-definition/$applicationDefinitionId/application/$applicationId'
      path: '/$applicationDefinitionId/application/$applicationId'
      fullPath: '/application-definition/$applicationDefinitionId/application/$applicationId'
      preLoaderRoute: typeof AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdImport
      parentRoute: typeof AuthApplicationDefinitionImport
    }
    '/_auth/project/$projectId/discussion/$discussionId': {
      id: '/_auth/project/$projectId/discussion/$discussionId'
      path: '/$discussionId'
      fullPath: '/project/$projectId/discussion/$discussionId'
      preLoaderRoute: typeof AuthProjectProjectIdDiscussionDiscussionIdImport
      parentRoute: typeof AuthProjectProjectIdDiscussionImport
    }
    '/_auth/_community/community/$communityId/': {
      id: '/_auth/_community/community/$communityId/'
      path: '/'
      fullPath: '/community/$communityId/'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_project/project/$projectId/': {
      id: '/_auth/_project/project/$projectId/'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof AuthProjectProjectProjectIdIndexImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_super-admin/super-admin/communities/': {
      id: '/_auth/_super-admin/super-admin/communities/'
      path: '/super-admin/communities'
      fullPath: '/super-admin/communities'
      preLoaderRoute: typeof AuthSuperAdminSuperAdminCommunitiesIndexImport
      parentRoute: typeof AuthSuperAdminImport
    }
    '/_auth/_super-admin/super-admin/methodologies/': {
      id: '/_auth/_super-admin/super-admin/methodologies/'
      path: '/super-admin/methodologies'
      fullPath: '/super-admin/methodologies'
      preLoaderRoute: typeof AuthSuperAdminSuperAdminMethodologiesIndexImport
      parentRoute: typeof AuthSuperAdminImport
    }
    '/_auth/_super-admin/super-admin/projects/': {
      id: '/_auth/_super-admin/super-admin/projects/'
      path: '/super-admin/projects'
      fullPath: '/super-admin/projects'
      preLoaderRoute: typeof AuthSuperAdminSuperAdminProjectsIndexImport
      parentRoute: typeof AuthSuperAdminImport
    }
    '/_auth/_super-admin/super-admin/statistics/': {
      id: '/_auth/_super-admin/super-admin/statistics/'
      path: '/super-admin/statistics'
      fullPath: '/super-admin/statistics'
      preLoaderRoute: typeof AuthSuperAdminSuperAdminStatisticsIndexImport
      parentRoute: typeof AuthSuperAdminImport
    }
    '/_auth/_super-admin/super-admin/users/': {
      id: '/_auth/_super-admin/super-admin/users/'
      path: '/super-admin/users'
      fullPath: '/super-admin/users'
      preLoaderRoute: typeof AuthSuperAdminSuperAdminUsersIndexImport
      parentRoute: typeof AuthSuperAdminImport
    }
    '/_auth/_community/community/$communityId/discussions/new': {
      id: '/_auth/_community/community/$communityId/discussions/new'
      path: '/discussions/new'
      fullPath: '/community/$communityId/discussions/new'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsNewImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId': {
      id: '/_auth/_community/community/$communityId/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/community/$communityId/project/$projectId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/project/create': {
      id: '/_auth/_community/community/$communityId/project/create'
      path: '/project/create'
      fullPath: '/community/$communityId/project/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_project/project/$projectId/discussions/new': {
      id: '/_auth/_project/project/$projectId/discussions/new'
      path: '/project/$projectId/discussions/new'
      fullPath: '/project/$projectId/discussions/new'
      preLoaderRoute: typeof AuthProjectProjectProjectIdDiscussionsNewImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/request/$requestId': {
      id: '/_auth/_project/project/$projectId/request/$requestId'
      path: '/project/$projectId/request/$requestId'
      fullPath: '/project/$projectId/request/$requestId'
      preLoaderRoute: typeof AuthProjectProjectProjectIdRequestRequestIdImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/request/new': {
      id: '/_auth/_project/project/$projectId/request/new'
      path: '/project/$projectId/request/new'
      fullPath: '/project/$projectId/request/new'
      preLoaderRoute: typeof AuthProjectProjectProjectIdRequestNewImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/account/notifications/tab-entity/$entityId/accept-invitation': {
      id: '/_auth/account/notifications/tab-entity/$entityId/accept-invitation'
      path: '/account/notifications/tab-entity/$entityId/accept-invitation'
      fullPath: '/account/notifications/tab-entity/$entityId/accept-invitation'
      preLoaderRoute: typeof AuthAccountNotificationsTabEntityEntityIdAcceptInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/account/notifications/tab-entity/$entityId/decline-invitation': {
      id: '/_auth/account/notifications/tab-entity/$entityId/decline-invitation'
      path: '/account/notifications/tab-entity/$entityId/decline-invitation'
      fullPath: '/account/notifications/tab-entity/$entityId/decline-invitation'
      preLoaderRoute: typeof AuthAccountNotificationsTabEntityEntityIdDeclineInvitationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_community/community/$communityId/application-definitions/': {
      id: '/_auth/_community/community/$communityId/application-definitions/'
      path: '/application-definitions'
      fullPath: '/community/$communityId/application-definitions'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/discussions/': {
      id: '/_auth/_community/community/$communityId/discussions/'
      path: '/discussions'
      fullPath: '/community/$communityId/discussions'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/projects/': {
      id: '/_auth/_community/community/$communityId/projects/'
      path: '/projects'
      fullPath: '/community/$communityId/projects'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/surveys/': {
      id: '/_auth/_community/community/$communityId/surveys/'
      path: '/surveys'
      fullPath: '/community/$communityId/surveys'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdSurveysIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_project/project/$projectId/discussions/': {
      id: '/_auth/_project/project/$projectId/discussions/'
      path: '/project/$projectId/discussions'
      fullPath: '/project/$projectId/discussions'
      preLoaderRoute: typeof AuthProjectProjectProjectIdDiscussionsIndexImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings'
      path: '/admin-panel/community-settings'
      fullPath: '/community/$communityId/admin-panel/community-settings'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings'
      path: '/admin-panel/event-settings'
      fullPath: '/community/$communityId/admin-panel/event-settings'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/application-definition-group/$groupId/responses': {
      id: '/_auth/_community/community/$communityId/application-definition-group/$groupId/responses'
      path: '/application-definition-group/$groupId/responses'
      fullPath: '/community/$communityId/application-definition-group/$groupId/responses'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/application-definitions/$applicationId/responses': {
      id: '/_auth/_community/community/$communityId/application-definitions/$applicationId/responses'
      path: '/application-definitions/$applicationId/responses'
      fullPath: '/community/$communityId/application-definitions/$applicationId/responses'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/discussions/$discussionId/edit': {
      id: '/_auth/_community/community/$communityId/discussions/$discussionId/edit'
      path: '/discussions/$discussionId/edit'
      fullPath: '/community/$communityId/discussions/$discussionId/edit'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/business-model': {
      id: '/_auth/_community/community/$communityId/project/$projectId/business-model'
      path: '/business-model'
      fullPath: '/community/$communityId/project/$projectId/business-model'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/kpis': {
      id: '/_auth/_community/community/$communityId/project/$projectId/kpis'
      path: '/kpis'
      fullPath: '/community/$communityId/project/$projectId/kpis'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdKpisImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/network': {
      id: '/_auth/_community/community/$communityId/project/$projectId/network'
      path: '/network'
      fullPath: '/community/$communityId/project/$projectId/network'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdNetworkImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/requests': {
      id: '/_auth/_community/community/$communityId/project/$projectId/requests'
      path: '/requests'
      fullPath: '/community/$communityId/project/$projectId/requests'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestsImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/resources': {
      id: '/_auth/_community/community/$communityId/project/$projectId/resources'
      path: '/resources'
      fullPath: '/community/$communityId/project/$projectId/resources'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdResourcesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/settings': {
      id: '/_auth/_community/community/$communityId/project/$projectId/settings'
      path: '/settings'
      fullPath: '/community/$communityId/project/$projectId/settings'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdSettingsImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/surveys': {
      id: '/_auth/_community/community/$communityId/project/$projectId/surveys'
      path: '/surveys'
      fullPath: '/community/$communityId/project/$projectId/surveys'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdSurveysImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/surveys/$surveyId/complete': {
      id: '/_auth/_community/community/$communityId/surveys/$surveyId/complete'
      path: '/surveys/$surveyId/complete'
      fullPath: '/community/$communityId/surveys/$surveyId/complete'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/surveys/$surveyId/responses': {
      id: '/_auth/_community/community/$communityId/surveys/$surveyId/responses'
      path: '/surveys/$surveyId/responses'
      fullPath: '/community/$communityId/surveys/$surveyId/responses'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/surveys/$surveyId/view': {
      id: '/_auth/_community/community/$communityId/surveys/$surveyId/view'
      path: '/surveys/$surveyId/view'
      fullPath: '/community/$communityId/surveys/$surveyId/view'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdViewImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_project/project/$projectId/discussions/$discussionId/edit': {
      id: '/_auth/_project/project/$projectId/discussions/$discussionId/edit'
      path: '/project/$projectId/discussions/$discussionId/edit'
      fullPath: '/project/$projectId/discussions/$discussionId/edit'
      preLoaderRoute: typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdEditImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_project/project/$projectId/request/edit/$requestId': {
      id: '/_auth/_project/project/$projectId/request/edit/$requestId'
      path: '/project/$projectId/request/edit/$requestId'
      fullPath: '/project/$projectId/request/edit/$requestId'
      preLoaderRoute: typeof AuthProjectProjectProjectIdRequestEditRequestIdImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/community/$communityId/application-definition/$appDefId/evaluate/$applicationId': {
      id: '/_auth/community/$communityId/application-definition/$appDefId/evaluate/$applicationId'
      path: '/community/$communityId/application-definition/$appDefId/evaluate/$applicationId'
      fullPath: '/community/$communityId/application-definition/$appDefId/evaluate/$applicationId'
      preLoaderRoute: typeof AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_community/community/$communityId/discussions/$discussionId/': {
      id: '/_auth/_community/community/$communityId/discussions/$discussionId/'
      path: '/discussions/$discussionId'
      fullPath: '/community/$communityId/discussions/$discussionId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/': {
      id: '/_auth/_community/community/$communityId/project/$projectId/'
      path: '/'
      fullPath: '/community/$communityId/project/$projectId/'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/tab/$tabId/': {
      id: '/_auth/_community/community/$communityId/tab/$tabId/'
      path: '/tab/$tabId'
      fullPath: '/community/$communityId/tab/$tabId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_project/project/$projectId/discussions/$discussionId/': {
      id: '/_auth/_project/project/$projectId/discussions/$discussionId/'
      path: '/project/$projectId/discussions/$discussionId'
      fullPath: '/project/$projectId/discussions/$discussionId'
      preLoaderRoute: typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexImport
      parentRoute: typeof AuthProjectImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create'
      path: '/admin-panel/application-definitions/create'
      fullPath: '/community/$communityId/admin-panel/application-definitions/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create'
      path: '/admin-panel/pages/create'
      fullPath: '/community/$communityId/admin-panel/pages/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create'
      path: '/admin-panel/programs/create'
      fullPath: '/community/$communityId/admin-panel/programs/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create'
      path: '/admin-panel/surveys/create'
      fullPath: '/community/$communityId/admin-panel/surveys/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': {
      id: '/_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
      path: '/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
      fullPath: '/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate/$responseId': {
      id: '/_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate/$responseId'
      path: '/application-definitions/$applicationId/evaluate/$responseId'
      fullPath: '/community/$communityId/application-definitions/$applicationId/evaluate/$responseId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/discussions/new': {
      id: '/_auth/_community/community/$communityId/project/$projectId/discussions/new'
      path: '/discussions/new'
      fullPath: '/community/$communityId/project/$projectId/discussions/new'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/request/$requestId': {
      id: '/_auth/_community/community/$communityId/project/$projectId/request/$requestId'
      path: '/request/$requestId'
      fullPath: '/community/$communityId/project/$projectId/request/$requestId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/request/new': {
      id: '/_auth/_community/community/$communityId/project/$projectId/request/new'
      path: '/request/new'
      fullPath: '/community/$communityId/project/$projectId/request/new'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/surveys/$surveyId/answers/$responseId': {
      id: '/_auth/_community/community/$communityId/surveys/$surveyId/answers/$responseId'
      path: '/surveys/$surveyId/answers/$responseId'
      fullPath: '/community/$communityId/surveys/$surveyId/answers/$responseId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/tab/$tabId/entity/create': {
      id: '/_auth/_community/community/$communityId/tab/$tabId/entity/create'
      path: '/tab/$tabId/entity/create'
      fullPath: '/community/$communityId/tab/$tabId/entity/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId': {
      id: '/_auth/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId'
      path: '/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId'
      fullPath: '/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId'
      preLoaderRoute: typeof AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/'
      path: '/admin-panel/activity-feed'
      fullPath: '/community/$communityId/admin-panel/activity-feed'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/'
      path: '/admin-panel/application-definitions'
      fullPath: '/community/$communityId/admin-panel/application-definitions'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/'
      path: '/admin-panel/circle-management'
      fullPath: '/community/$communityId/admin-panel/circle-management'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/'
      path: '/admin-panel/overview-projects'
      fullPath: '/community/$communityId/admin-panel/overview-projects'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/'
      path: '/admin-panel/pages'
      fullPath: '/community/$communityId/admin-panel/pages'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/'
      path: '/admin-panel/programs'
      fullPath: '/community/$communityId/admin-panel/programs'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/'
      path: '/admin-panel/requests-status'
      fullPath: '/community/$communityId/admin-panel/requests-status'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/'
      path: '/admin-panel/startup-kpis'
      fullPath: '/community/$communityId/admin-panel/startup-kpis'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/'
      path: '/admin-panel/startups-progress'
      fullPath: '/community/$communityId/admin-panel/startups-progress'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/'
      path: '/admin-panel/statistics'
      fullPath: '/community/$communityId/admin-panel/statistics'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/'
      path: '/admin-panel/surveys'
      fullPath: '/community/$communityId/admin-panel/surveys'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/users/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/users/'
      path: '/admin-panel/users'
      fullPath: '/community/$communityId/admin-panel/users'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/discussions/': {
      id: '/_auth/_community/community/$communityId/project/$projectId/discussions/'
      path: '/discussions'
      fullPath: '/community/$communityId/project/$projectId/discussions'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses'
      path: '/admin-panel/application-definition-group/$groupId/responses'
      fullPath: '/community/$communityId/admin-panel/application-definition-group/$groupId/responses'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses'
      path: '/admin-panel/application-definitions/$applicationId/responses'
      fullPath: '/community/$communityId/admin-panel/application-definitions/$applicationId/responses'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId'
      path: '/admin-panel/forms/application/$formId'
      fullPath: '/community/$communityId/admin-panel/forms/application/$formId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create'
      path: '/admin-panel/forms/application/create'
      fullPath: '/community/$communityId/admin-panel/forms/application/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId'
      path: '/admin-panel/forms/evaluation/$formId'
      fullPath: '/community/$communityId/admin-panel/forms/evaluation/$formId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create'
      path: '/admin-panel/forms/evaluation/create'
      fullPath: '/community/$communityId/admin-panel/forms/evaluation/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId'
      path: '/admin-panel/forms/methodology/$formId'
      fullPath: '/community/$communityId/admin-panel/forms/methodology/$formId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create'
      path: '/admin-panel/forms/methodology/create'
      fullPath: '/community/$communityId/admin-panel/forms/methodology/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId'
      path: '/admin-panel/forms/survey/$formId'
      fullPath: '/community/$communityId/admin-panel/forms/survey/$formId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create'
      path: '/admin-panel/forms/survey/create'
      fullPath: '/community/$communityId/admin-panel/forms/survey/create'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis'
      path: '/admin-panel/programs/$programId/kpis'
      fullPath: '/community/$communityId/admin-panel/programs/$programId/kpis'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people'
      path: '/admin-panel/programs/$programId/people'
      fullPath: '/community/$communityId/admin-panel/programs/$programId/people'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner'
      path: '/admin-panel/programs/$programId/planner'
      fullPath: '/community/$communityId/admin-panel/programs/$programId/planner'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview'
      path: '/admin-panel/surveys/$surveyId/preview'
      fullPath: '/community/$communityId/admin-panel/surveys/$surveyId/preview'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses'
      path: '/admin-panel/surveys/$surveyId/responses'
      fullPath: '/community/$communityId/admin-panel/surveys/$surveyId/responses'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view'
      path: '/admin-panel/surveys/$surveyId/view'
      fullPath: '/community/$communityId/admin-panel/surveys/$surveyId/view'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit': {
      id: '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit'
      path: '/discussions/$discussionId/edit'
      fullPath: '/community/$communityId/project/$projectId/discussions/$discussionId/edit'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/request/edit/$requestId': {
      id: '/_auth/_community/community/$communityId/project/$projectId/request/edit/$requestId'
      path: '/request/edit/$requestId'
      fullPath: '/community/$communityId/project/$projectId/request/edit/$requestId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network': {
      id: '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network'
      path: '/tab/$tabId/entity/$entityId/network'
      fullPath: '/community/$communityId/tab/$tabId/entity/$entityId/network'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings': {
      id: '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings'
      path: '/tab/$tabId/entity/$entityId/settings'
      fullPath: '/community/$communityId/tab/$tabId/entity/$entityId/settings'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/'
      path: '/admin-panel/application-definitions/$applicationId'
      fullPath: '/community/$communityId/admin-panel/application-definitions/$applicationId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/'
      path: '/admin-panel/forms/application'
      fullPath: '/community/$communityId/admin-panel/forms/application'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/'
      path: '/admin-panel/forms/evaluation'
      fullPath: '/community/$communityId/admin-panel/forms/evaluation'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/'
      path: '/admin-panel/forms/methodology'
      fullPath: '/community/$communityId/admin-panel/forms/methodology'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/'
      path: '/admin-panel/forms/survey'
      fullPath: '/community/$communityId/admin-panel/forms/survey'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/'
      path: '/admin-panel/pages/$pageId'
      fullPath: '/community/$communityId/admin-panel/pages/$pageId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/'
      path: '/admin-panel/programs/$programId'
      fullPath: '/community/$communityId/admin-panel/programs/$programId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/'
      path: '/admin-panel/surveys/$surveyId'
      fullPath: '/community/$communityId/admin-panel/surveys/$surveyId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/': {
      id: '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/'
      path: '/discussions/$discussionId'
      fullPath: '/community/$communityId/project/$projectId/discussions/$discussionId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdImport
    }
    '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/': {
      id: '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/'
      path: '/tab/$tabId/entity/$entityId'
      fullPath: '/community/$communityId/tab/$tabId/entity/$entityId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
      path: '/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
      fullPath: '/community/$communityId/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
    '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate/$responseId': {
      id: '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate/$responseId'
      path: '/admin-panel/application-definitions/$applicationId/evaluate/$responseId'
      fullPath: '/community/$communityId/admin-panel/application-definitions/$applicationId/evaluate/$responseId'
      preLoaderRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdImport
      parentRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelImport
    }
  }
}

// Create and export the route tree

interface AuthCommunityCommunityCommunityIdAdminPanelRouteChildren {
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
}

const AuthCommunityCommunityCommunityIdAdminPanelRouteChildren: AuthCommunityCommunityCommunityIdAdminPanelRouteChildren =
  {
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute,
    AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute:
      AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute,
  }

const AuthCommunityCommunityCommunityIdAdminPanelRouteWithChildren =
  AuthCommunityCommunityCommunityIdAdminPanelRoute._addFileChildren(
    AuthCommunityCommunityCommunityIdAdminPanelRouteChildren,
  )

interface AuthCommunityCommunityCommunityIdProjectProjectIdRouteChildren {
  AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute
}

const AuthCommunityCommunityCommunityIdProjectProjectIdRouteChildren: AuthCommunityCommunityCommunityIdProjectProjectIdRouteChildren =
  {
    AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute,
  }

const AuthCommunityCommunityCommunityIdProjectProjectIdRouteWithChildren =
  AuthCommunityCommunityCommunityIdProjectProjectIdRoute._addFileChildren(
    AuthCommunityCommunityCommunityIdProjectProjectIdRouteChildren,
  )

interface AuthCommunityCommunityCommunityIdRouteChildren {
  AuthCommunityCommunityCommunityIdAdminPanelRoute: typeof AuthCommunityCommunityCommunityIdAdminPanelRouteWithChildren
  AuthCommunityCommunityCommunityIdAboutRoute: typeof AuthCommunityCommunityCommunityIdAboutRoute
  AuthCommunityCommunityCommunityIdEventsRoute: typeof AuthCommunityCommunityCommunityIdEventsRoute
  AuthCommunityCommunityCommunityIdNetworkRoute: typeof AuthCommunityCommunityCommunityIdNetworkRoute
  AuthCommunityCommunityCommunityIdRequestsRoute: typeof AuthCommunityCommunityCommunityIdRequestsRoute
  AuthCommunityCommunityCommunityIdResourcesRoute: typeof AuthCommunityCommunityCommunityIdResourcesRoute
  AuthCommunityCommunityCommunityIdIndexRoute: typeof AuthCommunityCommunityCommunityIdIndexRoute
  AuthCommunityCommunityCommunityIdDiscussionsNewRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsNewRoute
  AuthCommunityCommunityCommunityIdProjectProjectIdRoute: typeof AuthCommunityCommunityCommunityIdProjectProjectIdRouteWithChildren
  AuthCommunityCommunityCommunityIdProjectCreateRoute: typeof AuthCommunityCommunityCommunityIdProjectCreateRoute
  AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute
  AuthCommunityCommunityCommunityIdDiscussionsIndexRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsIndexRoute
  AuthCommunityCommunityCommunityIdProjectsIndexRoute: typeof AuthCommunityCommunityCommunityIdProjectsIndexRoute
  AuthCommunityCommunityCommunityIdSurveysIndexRoute: typeof AuthCommunityCommunityCommunityIdSurveysIndexRoute
  AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute
  AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute
  AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute
  AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute
  AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute
  AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute
  AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute: typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute
  AuthCommunityCommunityCommunityIdTabTabIdIndexRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdIndexRoute
  AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute: typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
  AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute: typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute
  AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute
  AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute
  AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute
  AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute: typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute
}

const AuthCommunityCommunityCommunityIdRouteChildren: AuthCommunityCommunityCommunityIdRouteChildren =
  {
    AuthCommunityCommunityCommunityIdAdminPanelRoute:
      AuthCommunityCommunityCommunityIdAdminPanelRouteWithChildren,
    AuthCommunityCommunityCommunityIdAboutRoute:
      AuthCommunityCommunityCommunityIdAboutRoute,
    AuthCommunityCommunityCommunityIdEventsRoute:
      AuthCommunityCommunityCommunityIdEventsRoute,
    AuthCommunityCommunityCommunityIdNetworkRoute:
      AuthCommunityCommunityCommunityIdNetworkRoute,
    AuthCommunityCommunityCommunityIdRequestsRoute:
      AuthCommunityCommunityCommunityIdRequestsRoute,
    AuthCommunityCommunityCommunityIdResourcesRoute:
      AuthCommunityCommunityCommunityIdResourcesRoute,
    AuthCommunityCommunityCommunityIdIndexRoute:
      AuthCommunityCommunityCommunityIdIndexRoute,
    AuthCommunityCommunityCommunityIdDiscussionsNewRoute:
      AuthCommunityCommunityCommunityIdDiscussionsNewRoute,
    AuthCommunityCommunityCommunityIdProjectProjectIdRoute:
      AuthCommunityCommunityCommunityIdProjectProjectIdRouteWithChildren,
    AuthCommunityCommunityCommunityIdProjectCreateRoute:
      AuthCommunityCommunityCommunityIdProjectCreateRoute,
    AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute:
      AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute,
    AuthCommunityCommunityCommunityIdDiscussionsIndexRoute:
      AuthCommunityCommunityCommunityIdDiscussionsIndexRoute,
    AuthCommunityCommunityCommunityIdProjectsIndexRoute:
      AuthCommunityCommunityCommunityIdProjectsIndexRoute,
    AuthCommunityCommunityCommunityIdSurveysIndexRoute:
      AuthCommunityCommunityCommunityIdSurveysIndexRoute,
    AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute:
      AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute,
    AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute:
      AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute,
    AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute:
      AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute,
    AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute:
      AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute,
    AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute:
      AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute,
    AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute:
      AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute,
    AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute:
      AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute,
    AuthCommunityCommunityCommunityIdTabTabIdIndexRoute:
      AuthCommunityCommunityCommunityIdTabTabIdIndexRoute,
    AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute:
      AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute,
    AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute:
      AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute,
    AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute:
      AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute,
    AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute:
      AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute,
    AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute:
      AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute,
    AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute:
      AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute,
    AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute:
      AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute,
  }

const AuthCommunityCommunityCommunityIdRouteWithChildren =
  AuthCommunityCommunityCommunityIdRoute._addFileChildren(
    AuthCommunityCommunityCommunityIdRouteChildren,
  )

interface AuthCommunityRouteChildren {
  AuthCommunityCommunityCommunityIdRoute: typeof AuthCommunityCommunityCommunityIdRouteWithChildren
}

const AuthCommunityRouteChildren: AuthCommunityRouteChildren = {
  AuthCommunityCommunityCommunityIdRoute:
    AuthCommunityCommunityCommunityIdRouteWithChildren,
}

const AuthCommunityRouteWithChildren = AuthCommunityRoute._addFileChildren(
  AuthCommunityRouteChildren,
)

interface AuthProjectRouteChildren {
  AuthProjectProjectProjectIdBusinessModelRoute: typeof AuthProjectProjectProjectIdBusinessModelRoute
  AuthProjectProjectProjectIdKpisRoute: typeof AuthProjectProjectProjectIdKpisRoute
  AuthProjectProjectProjectIdNetworkRoute: typeof AuthProjectProjectProjectIdNetworkRoute
  AuthProjectProjectProjectIdRequestsRoute: typeof AuthProjectProjectProjectIdRequestsRoute
  AuthProjectProjectProjectIdResourcesRoute: typeof AuthProjectProjectProjectIdResourcesRoute
  AuthProjectProjectProjectIdSettingsRoute: typeof AuthProjectProjectProjectIdSettingsRoute
  AuthProjectProjectProjectIdSurveysRoute: typeof AuthProjectProjectProjectIdSurveysRoute
  AuthProjectProjectProjectIdIndexRoute: typeof AuthProjectProjectProjectIdIndexRoute
  AuthProjectProjectProjectIdDiscussionsNewRoute: typeof AuthProjectProjectProjectIdDiscussionsNewRoute
  AuthProjectProjectProjectIdRequestRequestIdRoute: typeof AuthProjectProjectProjectIdRequestRequestIdRoute
  AuthProjectProjectProjectIdRequestNewRoute: typeof AuthProjectProjectProjectIdRequestNewRoute
  AuthProjectProjectProjectIdDiscussionsIndexRoute: typeof AuthProjectProjectProjectIdDiscussionsIndexRoute
  AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute: typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute
  AuthProjectProjectProjectIdRequestEditRequestIdRoute: typeof AuthProjectProjectProjectIdRequestEditRequestIdRoute
  AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute: typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute
}

const AuthProjectRouteChildren: AuthProjectRouteChildren = {
  AuthProjectProjectProjectIdBusinessModelRoute:
    AuthProjectProjectProjectIdBusinessModelRoute,
  AuthProjectProjectProjectIdKpisRoute: AuthProjectProjectProjectIdKpisRoute,
  AuthProjectProjectProjectIdNetworkRoute:
    AuthProjectProjectProjectIdNetworkRoute,
  AuthProjectProjectProjectIdRequestsRoute:
    AuthProjectProjectProjectIdRequestsRoute,
  AuthProjectProjectProjectIdResourcesRoute:
    AuthProjectProjectProjectIdResourcesRoute,
  AuthProjectProjectProjectIdSettingsRoute:
    AuthProjectProjectProjectIdSettingsRoute,
  AuthProjectProjectProjectIdSurveysRoute:
    AuthProjectProjectProjectIdSurveysRoute,
  AuthProjectProjectProjectIdIndexRoute: AuthProjectProjectProjectIdIndexRoute,
  AuthProjectProjectProjectIdDiscussionsNewRoute:
    AuthProjectProjectProjectIdDiscussionsNewRoute,
  AuthProjectProjectProjectIdRequestRequestIdRoute:
    AuthProjectProjectProjectIdRequestRequestIdRoute,
  AuthProjectProjectProjectIdRequestNewRoute:
    AuthProjectProjectProjectIdRequestNewRoute,
  AuthProjectProjectProjectIdDiscussionsIndexRoute:
    AuthProjectProjectProjectIdDiscussionsIndexRoute,
  AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute:
    AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute,
  AuthProjectProjectProjectIdRequestEditRequestIdRoute:
    AuthProjectProjectProjectIdRequestEditRequestIdRoute,
  AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute:
    AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute,
}

const AuthProjectRouteWithChildren = AuthProjectRoute._addFileChildren(
  AuthProjectRouteChildren,
)

interface AuthSuperAdminRouteChildren {
  AuthSuperAdminSuperAdminCommunitiesIndexRoute: typeof AuthSuperAdminSuperAdminCommunitiesIndexRoute
  AuthSuperAdminSuperAdminMethodologiesIndexRoute: typeof AuthSuperAdminSuperAdminMethodologiesIndexRoute
  AuthSuperAdminSuperAdminProjectsIndexRoute: typeof AuthSuperAdminSuperAdminProjectsIndexRoute
  AuthSuperAdminSuperAdminStatisticsIndexRoute: typeof AuthSuperAdminSuperAdminStatisticsIndexRoute
  AuthSuperAdminSuperAdminUsersIndexRoute: typeof AuthSuperAdminSuperAdminUsersIndexRoute
}

const AuthSuperAdminRouteChildren: AuthSuperAdminRouteChildren = {
  AuthSuperAdminSuperAdminCommunitiesIndexRoute:
    AuthSuperAdminSuperAdminCommunitiesIndexRoute,
  AuthSuperAdminSuperAdminMethodologiesIndexRoute:
    AuthSuperAdminSuperAdminMethodologiesIndexRoute,
  AuthSuperAdminSuperAdminProjectsIndexRoute:
    AuthSuperAdminSuperAdminProjectsIndexRoute,
  AuthSuperAdminSuperAdminStatisticsIndexRoute:
    AuthSuperAdminSuperAdminStatisticsIndexRoute,
  AuthSuperAdminSuperAdminUsersIndexRoute:
    AuthSuperAdminSuperAdminUsersIndexRoute,
}

const AuthSuperAdminRouteWithChildren = AuthSuperAdminRoute._addFileChildren(
  AuthSuperAdminRouteChildren,
)

interface AuthUserAccountSettingsRouteChildren {
  AuthUserAccountSettingsProviderGoogleMeetRoute: typeof AuthUserAccountSettingsProviderGoogleMeetRoute
  AuthUserAccountSettingsProviderMsteamsRoute: typeof AuthUserAccountSettingsProviderMsteamsRoute
  AuthUserAccountSettingsProviderZoomRoute: typeof AuthUserAccountSettingsProviderZoomRoute
}

const AuthUserAccountSettingsRouteChildren: AuthUserAccountSettingsRouteChildren =
  {
    AuthUserAccountSettingsProviderGoogleMeetRoute:
      AuthUserAccountSettingsProviderGoogleMeetRoute,
    AuthUserAccountSettingsProviderMsteamsRoute:
      AuthUserAccountSettingsProviderMsteamsRoute,
    AuthUserAccountSettingsProviderZoomRoute:
      AuthUserAccountSettingsProviderZoomRoute,
  }

const AuthUserAccountSettingsRouteWithChildren =
  AuthUserAccountSettingsRoute._addFileChildren(
    AuthUserAccountSettingsRouteChildren,
  )

interface AuthUserRouteChildren {
  AuthUserEditProfileRoute: typeof AuthUserEditProfileRoute
  AuthUserAccountMyStuffRoute: typeof AuthUserAccountMyStuffRoute
  AuthUserAccountNotificationRoute: typeof AuthUserAccountNotificationRoute
  AuthUserAccountProfileRoute: typeof AuthUserAccountProfileRoute
  AuthUserAccountSettingsRoute: typeof AuthUserAccountSettingsRouteWithChildren
  AuthUserUserUserIdRoute: typeof AuthUserUserUserIdRoute
}

const AuthUserRouteChildren: AuthUserRouteChildren = {
  AuthUserEditProfileRoute: AuthUserEditProfileRoute,
  AuthUserAccountMyStuffRoute: AuthUserAccountMyStuffRoute,
  AuthUserAccountNotificationRoute: AuthUserAccountNotificationRoute,
  AuthUserAccountProfileRoute: AuthUserAccountProfileRoute,
  AuthUserAccountSettingsRoute: AuthUserAccountSettingsRouteWithChildren,
  AuthUserUserUserIdRoute: AuthUserUserUserIdRoute,
}

const AuthUserRouteWithChildren = AuthUserRoute._addFileChildren(
  AuthUserRouteChildren,
)

interface AuthApplicationDefinitionRouteChildren {
  AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute: typeof AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute
  AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute: typeof AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute
}

const AuthApplicationDefinitionRouteChildren: AuthApplicationDefinitionRouteChildren =
  {
    AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute:
      AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute,
    AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute:
      AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute,
  }

const AuthApplicationDefinitionRouteWithChildren =
  AuthApplicationDefinitionRoute._addFileChildren(
    AuthApplicationDefinitionRouteChildren,
  )

interface AuthProjectProjectIdDiscussionRouteChildren {
  AuthProjectProjectIdDiscussionDiscussionIdRoute: typeof AuthProjectProjectIdDiscussionDiscussionIdRoute
}

const AuthProjectProjectIdDiscussionRouteChildren: AuthProjectProjectIdDiscussionRouteChildren =
  {
    AuthProjectProjectIdDiscussionDiscussionIdRoute:
      AuthProjectProjectIdDiscussionDiscussionIdRoute,
  }

const AuthProjectProjectIdDiscussionRouteWithChildren =
  AuthProjectProjectIdDiscussionRoute._addFileChildren(
    AuthProjectProjectIdDiscussionRouteChildren,
  )

interface AuthProjectProjectIdRouteChildren {
  AuthProjectProjectIdBusinessModelRoute: typeof AuthProjectProjectIdBusinessModelRoute
  AuthProjectProjectIdDiscussionRoute: typeof AuthProjectProjectIdDiscussionRouteWithChildren
  AuthProjectProjectIdKpisRoute: typeof AuthProjectProjectIdKpisRoute
  AuthProjectProjectIdOverviewRoute: typeof AuthProjectProjectIdOverviewRoute
}

const AuthProjectProjectIdRouteChildren: AuthProjectProjectIdRouteChildren = {
  AuthProjectProjectIdBusinessModelRoute:
    AuthProjectProjectIdBusinessModelRoute,
  AuthProjectProjectIdDiscussionRoute:
    AuthProjectProjectIdDiscussionRouteWithChildren,
  AuthProjectProjectIdKpisRoute: AuthProjectProjectIdKpisRoute,
  AuthProjectProjectIdOverviewRoute: AuthProjectProjectIdOverviewRoute,
}

const AuthProjectProjectIdRouteWithChildren =
  AuthProjectProjectIdRoute._addFileChildren(AuthProjectProjectIdRouteChildren)

interface AuthRouteChildren {
  AuthCommunityRoute: typeof AuthCommunityRouteWithChildren
  AuthProjectRoute: typeof AuthProjectRouteWithChildren
  AuthSuperAdminRoute: typeof AuthSuperAdminRouteWithChildren
  AuthUserRoute: typeof AuthUserRouteWithChildren
  AuthApplicationDefinitionRoute: typeof AuthApplicationDefinitionRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthProjectProjectIdRoute: typeof AuthProjectProjectIdRouteWithChildren
  AuthRequestAcceptInvitationRoute: typeof AuthRequestAcceptInvitationRoute
  AuthRequestDeclineInvitationRoute: typeof AuthRequestDeclineInvitationRoute
  AuthCommunityCommunityIdDiscussionRoute: typeof AuthCommunityCommunityIdDiscussionRoute
  AuthCommunityCommunityIdMembersRoute: typeof AuthCommunityCommunityIdMembersRoute
  AuthCommunityCommunityIdOverviewRoute: typeof AuthCommunityCommunityIdOverviewRoute
  AuthCommunityEntityIdAcceptInvitationRoute: typeof AuthCommunityEntityIdAcceptInvitationRoute
  AuthCommunityEntityIdDeclineInvitationRoute: typeof AuthCommunityEntityIdDeclineInvitationRoute
  AuthProjectEntityIdAcceptInvitationRoute: typeof AuthProjectEntityIdAcceptInvitationRoute
  AuthProjectEntityIdDeclineInvitationRoute: typeof AuthProjectEntityIdDeclineInvitationRoute
  AuthTabEntityEntityIdAcceptInvitationRoute: typeof AuthTabEntityEntityIdAcceptInvitationRoute
  AuthTabEntityEntityIdDeclineInvitationRoute: typeof AuthTabEntityEntityIdDeclineInvitationRoute
  AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute: typeof AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute
  AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute: typeof AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute
  AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute: typeof AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
  AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute: typeof AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCommunityRoute: AuthCommunityRouteWithChildren,
  AuthProjectRoute: AuthProjectRouteWithChildren,
  AuthSuperAdminRoute: AuthSuperAdminRouteWithChildren,
  AuthUserRoute: AuthUserRouteWithChildren,
  AuthApplicationDefinitionRoute: AuthApplicationDefinitionRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthProjectProjectIdRoute: AuthProjectProjectIdRouteWithChildren,
  AuthRequestAcceptInvitationRoute: AuthRequestAcceptInvitationRoute,
  AuthRequestDeclineInvitationRoute: AuthRequestDeclineInvitationRoute,
  AuthCommunityCommunityIdDiscussionRoute:
    AuthCommunityCommunityIdDiscussionRoute,
  AuthCommunityCommunityIdMembersRoute: AuthCommunityCommunityIdMembersRoute,
  AuthCommunityCommunityIdOverviewRoute: AuthCommunityCommunityIdOverviewRoute,
  AuthCommunityEntityIdAcceptInvitationRoute:
    AuthCommunityEntityIdAcceptInvitationRoute,
  AuthCommunityEntityIdDeclineInvitationRoute:
    AuthCommunityEntityIdDeclineInvitationRoute,
  AuthProjectEntityIdAcceptInvitationRoute:
    AuthProjectEntityIdAcceptInvitationRoute,
  AuthProjectEntityIdDeclineInvitationRoute:
    AuthProjectEntityIdDeclineInvitationRoute,
  AuthTabEntityEntityIdAcceptInvitationRoute:
    AuthTabEntityEntityIdAcceptInvitationRoute,
  AuthTabEntityEntityIdDeclineInvitationRoute:
    AuthTabEntityEntityIdDeclineInvitationRoute,
  AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute:
    AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute,
  AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute:
    AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute,
  AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute:
    AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute,
  AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute:
    AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface UnauthLandingRouteChildren {
  UnauthLandingIndexRoute: typeof UnauthLandingIndexRoute
  UnauthLandingDiscussionDiscussionIdRoute: typeof UnauthLandingDiscussionDiscussionIdRoute
  UnauthLandingEntityEntityIdRoute: typeof UnauthLandingEntityEntityIdRoute
  UnauthLandingProjectProjectIdRoute: typeof UnauthLandingProjectProjectIdRoute
  UnauthLandingProjectsCommunityIdRoute: typeof UnauthLandingProjectsCommunityIdRoute
  UnauthLandingRequestRequestIdRoute: typeof UnauthLandingRequestRequestIdRoute
  UnauthLandingTabTabIdRoute: typeof UnauthLandingTabTabIdRoute
}

const UnauthLandingRouteChildren: UnauthLandingRouteChildren = {
  UnauthLandingIndexRoute: UnauthLandingIndexRoute,
  UnauthLandingDiscussionDiscussionIdRoute:
    UnauthLandingDiscussionDiscussionIdRoute,
  UnauthLandingEntityEntityIdRoute: UnauthLandingEntityEntityIdRoute,
  UnauthLandingProjectProjectIdRoute: UnauthLandingProjectProjectIdRoute,
  UnauthLandingProjectsCommunityIdRoute: UnauthLandingProjectsCommunityIdRoute,
  UnauthLandingRequestRequestIdRoute: UnauthLandingRequestRequestIdRoute,
  UnauthLandingTabTabIdRoute: UnauthLandingTabTabIdRoute,
}

const UnauthLandingRouteWithChildren = UnauthLandingRoute._addFileChildren(
  UnauthLandingRouteChildren,
)

interface UnauthRouteChildren {
  UnauthForgotPasswordRoute: typeof UnauthForgotPasswordRoute
  UnauthLandingRoute: typeof UnauthLandingRouteWithChildren
  UnauthLoginRoute: typeof UnauthLoginRoute
  UnauthSignupRoute: typeof UnauthSignupRoute
  UnauthActivateCodeRoute: typeof UnauthActivateCodeRoute
  UnauthResetPasswordActivationCodeRoute: typeof UnauthResetPasswordActivationCodeRoute
  UnauthActivateActivateAccountCodePasswordCodeRoute: typeof UnauthActivateActivateAccountCodePasswordCodeRoute
}

const UnauthRouteChildren: UnauthRouteChildren = {
  UnauthForgotPasswordRoute: UnauthForgotPasswordRoute,
  UnauthLandingRoute: UnauthLandingRouteWithChildren,
  UnauthLoginRoute: UnauthLoginRoute,
  UnauthSignupRoute: UnauthSignupRoute,
  UnauthActivateCodeRoute: UnauthActivateCodeRoute,
  UnauthResetPasswordActivationCodeRoute:
    UnauthResetPasswordActivationCodeRoute,
  UnauthActivateActivateAccountCodePasswordCodeRoute:
    UnauthActivateActivateAccountCodePasswordCodeRoute,
}

const UnauthRouteWithChildren =
  UnauthRoute._addFileChildren(UnauthRouteChildren)

interface ApplicationDefinitionApplicationDefinitionIdRouteChildren {
  ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute: typeof ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute
  ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute: typeof ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute
  ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute: typeof ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute
}

const ApplicationDefinitionApplicationDefinitionIdRouteChildren: ApplicationDefinitionApplicationDefinitionIdRouteChildren =
  {
    ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute:
      ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute,
    ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute:
      ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute,
    ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute:
      ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute,
  }

const ApplicationDefinitionApplicationDefinitionIdRouteWithChildren =
  ApplicationDefinitionApplicationDefinitionIdRoute._addFileChildren(
    ApplicationDefinitionApplicationDefinitionIdRouteChildren,
  )

export interface FileRoutesByFullPath {
  '': typeof AuthUserRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/application-definition': typeof AuthApplicationDefinitionRouteWithChildren
  '/forgot-password': typeof UnauthForgotPasswordRoute
  '/landing': typeof UnauthLandingRouteWithChildren
  '/login': typeof UnauthLoginRoute
  '/signup': typeof UnauthSignupRoute
  '/application-definition/$applicationDefinitionId': typeof ApplicationDefinitionApplicationDefinitionIdRouteWithChildren
  '/calendar-redirect/provider-google-meet': typeof CalendarRedirectProviderGoogleMeetRoute
  '/calendar-redirect/provider-msteams': typeof CalendarRedirectProviderMsteamsRoute
  '/calendar-redirect/provider-zoom': typeof CalendarRedirectProviderZoomRoute
  '/': typeof AuthIndexRoute
  '/calendar-redirect': typeof CalendarRedirectIndexRoute
  '/edit-profile': typeof AuthUserEditProfileRoute
  '/project/$projectId': typeof AuthProjectProjectProjectIdIndexRoute
  '/request/accept-invitation': typeof AuthRequestAcceptInvitationRoute
  '/request/decline-invitation': typeof AuthRequestDeclineInvitationRoute
  '/activate/$code': typeof UnauthActivateCodeRoute
  '/reset-password/$activationCode': typeof UnauthResetPasswordActivationCodeRoute
  '/landing/': typeof UnauthLandingIndexRoute
  '/account/my-stuff': typeof AuthUserAccountMyStuffRoute
  '/account/notification': typeof AuthUserAccountNotificationRoute
  '/account/profile': typeof AuthUserAccountProfileRoute
  '/account/settings': typeof AuthUserAccountSettingsRouteWithChildren
  '/user/$userId': typeof AuthUserUserUserIdRoute
  '/community/$communityId/discussion': typeof AuthCommunityCommunityIdDiscussionRoute
  '/community/$communityId/members': typeof AuthCommunityCommunityIdMembersRoute
  '/community/$communityId/overview': typeof AuthCommunityCommunityIdOverviewRoute
  '/community/$entityId/accept-invitation': typeof AuthCommunityEntityIdAcceptInvitationRoute
  '/community/$entityId/decline-invitation': typeof AuthCommunityEntityIdDeclineInvitationRoute
  '/project/$entityId/accept-invitation': typeof AuthProjectEntityIdAcceptInvitationRoute
  '/project/$entityId/decline-invitation': typeof AuthProjectEntityIdDeclineInvitationRoute
  '/project/$projectId/business-model': typeof AuthProjectProjectProjectIdBusinessModelRoute
  '/project/$projectId/discussion': typeof AuthProjectProjectIdDiscussionRouteWithChildren
  '/project/$projectId/kpis': typeof AuthProjectProjectProjectIdKpisRoute
  '/project/$projectId/overview': typeof AuthProjectProjectIdOverviewRoute
  '/tab-entity/$entityId/accept-invitation': typeof AuthTabEntityEntityIdAcceptInvitationRoute
  '/tab-entity/$entityId/decline-invitation': typeof AuthTabEntityEntityIdDeclineInvitationRoute
  '/activate/$activateAccountCode/$passwordCode': typeof UnauthActivateActivateAccountCodePasswordCodeRoute
  '/landing/discussion/$discussionId': typeof UnauthLandingDiscussionDiscussionIdRoute
  '/landing/entity/$entityId': typeof UnauthLandingEntityEntityIdRoute
  '/landing/project/$projectId': typeof UnauthLandingProjectProjectIdRoute
  '/landing/projects/$communityId': typeof UnauthLandingProjectsCommunityIdRoute
  '/landing/request/$requestId': typeof UnauthLandingRequestRequestIdRoute
  '/landing/tab/$tabId': typeof UnauthLandingTabTabIdRoute
  '/application-definition/$applicationDefinitionId/application/$applicationId': typeof AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute
  '/application-definition/$applicationDefinitionId/application/create': typeof ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute
  '/application-definition/$applicationDefinitionId/application/new-application': typeof ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute
  '/events/public/join/$token': typeof EventsPublicJoinTokenRoute
  '/community/$communityId': typeof AuthCommunityCommunityCommunityIdAdminPanelRouteWithChildren
  '/community/$communityId/about': typeof AuthCommunityCommunityCommunityIdAboutRoute
  '/community/$communityId/events': typeof AuthCommunityCommunityCommunityIdEventsRoute
  '/community/$communityId/network': typeof AuthCommunityCommunityCommunityIdNetworkRoute
  '/community/$communityId/requests': typeof AuthCommunityCommunityCommunityIdRequestsRoute
  '/community/$communityId/resources': typeof AuthCommunityCommunityCommunityIdResourcesRoute
  '/project/$projectId/network': typeof AuthProjectProjectProjectIdNetworkRoute
  '/project/$projectId/requests': typeof AuthProjectProjectProjectIdRequestsRoute
  '/project/$projectId/resources': typeof AuthProjectProjectProjectIdResourcesRoute
  '/project/$projectId/settings': typeof AuthProjectProjectProjectIdSettingsRoute
  '/project/$projectId/surveys': typeof AuthProjectProjectProjectIdSurveysRoute
  '/account/settings/provider-google-meet': typeof AuthUserAccountSettingsProviderGoogleMeetRoute
  '/account/settings/provider-msteams': typeof AuthUserAccountSettingsProviderMsteamsRoute
  '/account/settings/provider-zoom': typeof AuthUserAccountSettingsProviderZoomRoute
  '/application-definition/$appDefId/evaluate-application/$applicationId': typeof AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute
  '/project/$projectId/discussion/$discussionId': typeof AuthProjectProjectIdDiscussionDiscussionIdRoute
  '/community/$communityId/': typeof AuthCommunityCommunityCommunityIdIndexRoute
  '/super-admin/communities': typeof AuthSuperAdminSuperAdminCommunitiesIndexRoute
  '/super-admin/methodologies': typeof AuthSuperAdminSuperAdminMethodologiesIndexRoute
  '/super-admin/projects': typeof AuthSuperAdminSuperAdminProjectsIndexRoute
  '/super-admin/statistics': typeof AuthSuperAdminSuperAdminStatisticsIndexRoute
  '/super-admin/users': typeof AuthSuperAdminSuperAdminUsersIndexRoute
  '/community/$communityId/discussions/new': typeof AuthCommunityCommunityCommunityIdDiscussionsNewRoute
  '/community/$communityId/project/$projectId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRouteWithChildren
  '/community/$communityId/project/create': typeof AuthCommunityCommunityCommunityIdProjectCreateRoute
  '/project/$projectId/discussions/new': typeof AuthProjectProjectProjectIdDiscussionsNewRoute
  '/project/$projectId/request/$requestId': typeof AuthProjectProjectProjectIdRequestRequestIdRoute
  '/project/$projectId/request/new': typeof AuthProjectProjectProjectIdRequestNewRoute
  '/account/notifications/tab-entity/$entityId/accept-invitation': typeof AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute
  '/account/notifications/tab-entity/$entityId/decline-invitation': typeof AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute
  '/community/$communityId/application-definitions': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute
  '/community/$communityId/discussions': typeof AuthCommunityCommunityCommunityIdDiscussionsIndexRoute
  '/community/$communityId/projects': typeof AuthCommunityCommunityCommunityIdProjectsIndexRoute
  '/community/$communityId/surveys': typeof AuthCommunityCommunityCommunityIdSurveysIndexRoute
  '/project/$projectId/discussions': typeof AuthProjectProjectProjectIdDiscussionsIndexRoute
  '/community/$communityId/admin-panel/community-settings': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute
  '/community/$communityId/admin-panel/event-settings': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute
  '/community/$communityId/application-definition-group/$groupId/responses': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute
  '/community/$communityId/application-definitions/$applicationId/responses': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute
  '/community/$communityId/discussions/$discussionId/edit': typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute
  '/community/$communityId/project/$projectId/business-model': typeof AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute
  '/community/$communityId/project/$projectId/kpis': typeof AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute
  '/community/$communityId/project/$projectId/network': typeof AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute
  '/community/$communityId/project/$projectId/requests': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute
  '/community/$communityId/project/$projectId/resources': typeof AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute
  '/community/$communityId/project/$projectId/settings': typeof AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute
  '/community/$communityId/project/$projectId/surveys': typeof AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute
  '/community/$communityId/surveys/$surveyId/complete': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute
  '/community/$communityId/surveys/$surveyId/responses': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute
  '/community/$communityId/surveys/$surveyId/view': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute
  '/project/$projectId/discussions/$discussionId/edit': typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute
  '/project/$projectId/request/edit/$requestId': typeof AuthProjectProjectProjectIdRequestEditRequestIdRoute
  '/community/$communityId/application-definition/$appDefId/evaluate/$applicationId': typeof AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
  '/community/$communityId/discussions/$discussionId': typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute
  '/community/$communityId/project/$projectId/': typeof AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute
  '/community/$communityId/tab/$tabId': typeof AuthCommunityCommunityCommunityIdTabTabIdIndexRoute
  '/project/$projectId/discussions/$discussionId': typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute
  '/community/$communityId/admin-panel/application-definitions/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute
  '/community/$communityId/admin-panel/pages/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute
  '/community/$communityId/admin-panel/programs/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute
  '/community/$communityId/admin-panel/surveys/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute
  '/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  '/community/$communityId/application-definitions/$applicationId/evaluate/$responseId': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
  '/community/$communityId/project/$projectId/discussions/new': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute
  '/community/$communityId/project/$projectId/request/$requestId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute
  '/community/$communityId/project/$projectId/request/new': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute
  '/community/$communityId/surveys/$surveyId/answers/$responseId': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute
  '/community/$communityId/tab/$tabId/entity/create': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute
  '/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId': typeof AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
  '/community/$communityId/admin-panel/activity-feed': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute
  '/community/$communityId/admin-panel/application-definitions': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute
  '/community/$communityId/admin-panel/circle-management': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute
  '/community/$communityId/admin-panel/overview-projects': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute
  '/community/$communityId/admin-panel/pages': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute
  '/community/$communityId/admin-panel/programs': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute
  '/community/$communityId/admin-panel/requests-status': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute
  '/community/$communityId/admin-panel/startup-kpis': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute
  '/community/$communityId/admin-panel/startups-progress': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute
  '/community/$communityId/admin-panel/statistics': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute
  '/community/$communityId/admin-panel/surveys': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute
  '/community/$communityId/admin-panel/users': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute
  '/community/$communityId/project/$projectId/discussions': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute
  '/community/$communityId/admin-panel/application-definition-group/$groupId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute
  '/community/$communityId/admin-panel/application-definitions/$applicationId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute
  '/community/$communityId/admin-panel/forms/application/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute
  '/community/$communityId/admin-panel/forms/application/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute
  '/community/$communityId/admin-panel/forms/evaluation/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute
  '/community/$communityId/admin-panel/forms/evaluation/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute
  '/community/$communityId/admin-panel/forms/methodology/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute
  '/community/$communityId/admin-panel/forms/methodology/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute
  '/community/$communityId/admin-panel/forms/survey/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute
  '/community/$communityId/admin-panel/forms/survey/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute
  '/community/$communityId/admin-panel/programs/$programId/kpis': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute
  '/community/$communityId/admin-panel/programs/$programId/people': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute
  '/community/$communityId/admin-panel/programs/$programId/planner': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute
  '/community/$communityId/admin-panel/surveys/$surveyId/preview': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute
  '/community/$communityId/admin-panel/surveys/$surveyId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute
  '/community/$communityId/admin-panel/surveys/$surveyId/view': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute
  '/community/$communityId/project/$projectId/discussions/$discussionId/edit': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute
  '/community/$communityId/project/$projectId/request/edit/$requestId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute
  '/community/$communityId/tab/$tabId/entity/$entityId/network': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute
  '/community/$communityId/tab/$tabId/entity/$entityId/settings': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute
  '/community/$communityId/admin-panel/application-definitions/$applicationId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute
  '/community/$communityId/admin-panel/forms/application': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute
  '/community/$communityId/admin-panel/forms/evaluation': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute
  '/community/$communityId/admin-panel/forms/methodology': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute
  '/community/$communityId/admin-panel/forms/survey': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute
  '/community/$communityId/admin-panel/pages/$pageId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute
  '/community/$communityId/admin-panel/programs/$programId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute
  '/community/$communityId/admin-panel/surveys/$surveyId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute
  '/community/$communityId/project/$projectId/discussions/$discussionId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute
  '/community/$communityId/tab/$tabId/entity/$entityId': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute
  '/community/$communityId/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  '/community/$communityId/admin-panel/application-definitions/$applicationId/evaluate/$responseId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
}

export interface FileRoutesByTo {
  '': typeof AuthUserRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/application-definition': typeof AuthApplicationDefinitionRouteWithChildren
  '/forgot-password': typeof UnauthForgotPasswordRoute
  '/login': typeof UnauthLoginRoute
  '/signup': typeof UnauthSignupRoute
  '/application-definition/$applicationDefinitionId': typeof ApplicationDefinitionApplicationDefinitionIdRouteWithChildren
  '/calendar-redirect/provider-google-meet': typeof CalendarRedirectProviderGoogleMeetRoute
  '/calendar-redirect/provider-msteams': typeof CalendarRedirectProviderMsteamsRoute
  '/calendar-redirect/provider-zoom': typeof CalendarRedirectProviderZoomRoute
  '/': typeof AuthIndexRoute
  '/calendar-redirect': typeof CalendarRedirectIndexRoute
  '/edit-profile': typeof AuthUserEditProfileRoute
  '/project/$projectId': typeof AuthProjectProjectProjectIdIndexRoute
  '/request/accept-invitation': typeof AuthRequestAcceptInvitationRoute
  '/request/decline-invitation': typeof AuthRequestDeclineInvitationRoute
  '/activate/$code': typeof UnauthActivateCodeRoute
  '/reset-password/$activationCode': typeof UnauthResetPasswordActivationCodeRoute
  '/landing': typeof UnauthLandingIndexRoute
  '/account/my-stuff': typeof AuthUserAccountMyStuffRoute
  '/account/notification': typeof AuthUserAccountNotificationRoute
  '/account/profile': typeof AuthUserAccountProfileRoute
  '/account/settings': typeof AuthUserAccountSettingsRouteWithChildren
  '/user/$userId': typeof AuthUserUserUserIdRoute
  '/community/$communityId/discussion': typeof AuthCommunityCommunityIdDiscussionRoute
  '/community/$communityId/members': typeof AuthCommunityCommunityIdMembersRoute
  '/community/$communityId/overview': typeof AuthCommunityCommunityIdOverviewRoute
  '/community/$entityId/accept-invitation': typeof AuthCommunityEntityIdAcceptInvitationRoute
  '/community/$entityId/decline-invitation': typeof AuthCommunityEntityIdDeclineInvitationRoute
  '/project/$entityId/accept-invitation': typeof AuthProjectEntityIdAcceptInvitationRoute
  '/project/$entityId/decline-invitation': typeof AuthProjectEntityIdDeclineInvitationRoute
  '/project/$projectId/business-model': typeof AuthProjectProjectProjectIdBusinessModelRoute
  '/project/$projectId/discussion': typeof AuthProjectProjectIdDiscussionRouteWithChildren
  '/project/$projectId/kpis': typeof AuthProjectProjectProjectIdKpisRoute
  '/project/$projectId/overview': typeof AuthProjectProjectIdOverviewRoute
  '/tab-entity/$entityId/accept-invitation': typeof AuthTabEntityEntityIdAcceptInvitationRoute
  '/tab-entity/$entityId/decline-invitation': typeof AuthTabEntityEntityIdDeclineInvitationRoute
  '/activate/$activateAccountCode/$passwordCode': typeof UnauthActivateActivateAccountCodePasswordCodeRoute
  '/landing/discussion/$discussionId': typeof UnauthLandingDiscussionDiscussionIdRoute
  '/landing/entity/$entityId': typeof UnauthLandingEntityEntityIdRoute
  '/landing/project/$projectId': typeof UnauthLandingProjectProjectIdRoute
  '/landing/projects/$communityId': typeof UnauthLandingProjectsCommunityIdRoute
  '/landing/request/$requestId': typeof UnauthLandingRequestRequestIdRoute
  '/landing/tab/$tabId': typeof UnauthLandingTabTabIdRoute
  '/application-definition/$applicationDefinitionId/application/$applicationId': typeof AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute
  '/application-definition/$applicationDefinitionId/application/create': typeof ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute
  '/application-definition/$applicationDefinitionId/application/new-application': typeof ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute
  '/events/public/join/$token': typeof EventsPublicJoinTokenRoute
  '/community/$communityId': typeof AuthCommunityCommunityCommunityIdIndexRoute
  '/community/$communityId/about': typeof AuthCommunityCommunityCommunityIdAboutRoute
  '/community/$communityId/events': typeof AuthCommunityCommunityCommunityIdEventsRoute
  '/community/$communityId/network': typeof AuthCommunityCommunityCommunityIdNetworkRoute
  '/community/$communityId/requests': typeof AuthCommunityCommunityCommunityIdRequestsRoute
  '/community/$communityId/resources': typeof AuthCommunityCommunityCommunityIdResourcesRoute
  '/project/$projectId/network': typeof AuthProjectProjectProjectIdNetworkRoute
  '/project/$projectId/requests': typeof AuthProjectProjectProjectIdRequestsRoute
  '/project/$projectId/resources': typeof AuthProjectProjectProjectIdResourcesRoute
  '/project/$projectId/settings': typeof AuthProjectProjectProjectIdSettingsRoute
  '/project/$projectId/surveys': typeof AuthProjectProjectProjectIdSurveysRoute
  '/account/settings/provider-google-meet': typeof AuthUserAccountSettingsProviderGoogleMeetRoute
  '/account/settings/provider-msteams': typeof AuthUserAccountSettingsProviderMsteamsRoute
  '/account/settings/provider-zoom': typeof AuthUserAccountSettingsProviderZoomRoute
  '/application-definition/$appDefId/evaluate-application/$applicationId': typeof AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute
  '/project/$projectId/discussion/$discussionId': typeof AuthProjectProjectIdDiscussionDiscussionIdRoute
  '/super-admin/communities': typeof AuthSuperAdminSuperAdminCommunitiesIndexRoute
  '/super-admin/methodologies': typeof AuthSuperAdminSuperAdminMethodologiesIndexRoute
  '/super-admin/projects': typeof AuthSuperAdminSuperAdminProjectsIndexRoute
  '/super-admin/statistics': typeof AuthSuperAdminSuperAdminStatisticsIndexRoute
  '/super-admin/users': typeof AuthSuperAdminSuperAdminUsersIndexRoute
  '/community/$communityId/discussions/new': typeof AuthCommunityCommunityCommunityIdDiscussionsNewRoute
  '/community/$communityId/project/create': typeof AuthCommunityCommunityCommunityIdProjectCreateRoute
  '/project/$projectId/discussions/new': typeof AuthProjectProjectProjectIdDiscussionsNewRoute
  '/project/$projectId/request/$requestId': typeof AuthProjectProjectProjectIdRequestRequestIdRoute
  '/project/$projectId/request/new': typeof AuthProjectProjectProjectIdRequestNewRoute
  '/account/notifications/tab-entity/$entityId/accept-invitation': typeof AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute
  '/account/notifications/tab-entity/$entityId/decline-invitation': typeof AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute
  '/community/$communityId/application-definitions': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute
  '/community/$communityId/discussions': typeof AuthCommunityCommunityCommunityIdDiscussionsIndexRoute
  '/community/$communityId/projects': typeof AuthCommunityCommunityCommunityIdProjectsIndexRoute
  '/community/$communityId/surveys': typeof AuthCommunityCommunityCommunityIdSurveysIndexRoute
  '/project/$projectId/discussions': typeof AuthProjectProjectProjectIdDiscussionsIndexRoute
  '/community/$communityId/admin-panel/community-settings': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute
  '/community/$communityId/admin-panel/event-settings': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute
  '/community/$communityId/application-definition-group/$groupId/responses': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute
  '/community/$communityId/application-definitions/$applicationId/responses': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute
  '/community/$communityId/discussions/$discussionId/edit': typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute
  '/community/$communityId/project/$projectId/business-model': typeof AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute
  '/community/$communityId/project/$projectId/kpis': typeof AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute
  '/community/$communityId/project/$projectId/network': typeof AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute
  '/community/$communityId/project/$projectId/requests': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute
  '/community/$communityId/project/$projectId/resources': typeof AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute
  '/community/$communityId/project/$projectId/settings': typeof AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute
  '/community/$communityId/project/$projectId/surveys': typeof AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute
  '/community/$communityId/surveys/$surveyId/complete': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute
  '/community/$communityId/surveys/$surveyId/responses': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute
  '/community/$communityId/surveys/$surveyId/view': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute
  '/project/$projectId/discussions/$discussionId/edit': typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute
  '/project/$projectId/request/edit/$requestId': typeof AuthProjectProjectProjectIdRequestEditRequestIdRoute
  '/community/$communityId/application-definition/$appDefId/evaluate/$applicationId': typeof AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
  '/community/$communityId/discussions/$discussionId': typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute
  '/community/$communityId/project/$projectId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute
  '/community/$communityId/tab/$tabId': typeof AuthCommunityCommunityCommunityIdTabTabIdIndexRoute
  '/project/$projectId/discussions/$discussionId': typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute
  '/community/$communityId/admin-panel/application-definitions/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute
  '/community/$communityId/admin-panel/pages/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute
  '/community/$communityId/admin-panel/programs/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute
  '/community/$communityId/admin-panel/surveys/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute
  '/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  '/community/$communityId/application-definitions/$applicationId/evaluate/$responseId': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
  '/community/$communityId/project/$projectId/discussions/new': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute
  '/community/$communityId/project/$projectId/request/$requestId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute
  '/community/$communityId/project/$projectId/request/new': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute
  '/community/$communityId/surveys/$surveyId/answers/$responseId': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute
  '/community/$communityId/tab/$tabId/entity/create': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute
  '/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId': typeof AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
  '/community/$communityId/admin-panel/activity-feed': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute
  '/community/$communityId/admin-panel/application-definitions': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute
  '/community/$communityId/admin-panel/circle-management': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute
  '/community/$communityId/admin-panel/overview-projects': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute
  '/community/$communityId/admin-panel/pages': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute
  '/community/$communityId/admin-panel/programs': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute
  '/community/$communityId/admin-panel/requests-status': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute
  '/community/$communityId/admin-panel/startup-kpis': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute
  '/community/$communityId/admin-panel/startups-progress': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute
  '/community/$communityId/admin-panel/statistics': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute
  '/community/$communityId/admin-panel/surveys': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute
  '/community/$communityId/admin-panel/users': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute
  '/community/$communityId/project/$projectId/discussions': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute
  '/community/$communityId/admin-panel/application-definition-group/$groupId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute
  '/community/$communityId/admin-panel/application-definitions/$applicationId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute
  '/community/$communityId/admin-panel/forms/application/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute
  '/community/$communityId/admin-panel/forms/application/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute
  '/community/$communityId/admin-panel/forms/evaluation/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute
  '/community/$communityId/admin-panel/forms/evaluation/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute
  '/community/$communityId/admin-panel/forms/methodology/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute
  '/community/$communityId/admin-panel/forms/methodology/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute
  '/community/$communityId/admin-panel/forms/survey/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute
  '/community/$communityId/admin-panel/forms/survey/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute
  '/community/$communityId/admin-panel/programs/$programId/kpis': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute
  '/community/$communityId/admin-panel/programs/$programId/people': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute
  '/community/$communityId/admin-panel/programs/$programId/planner': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute
  '/community/$communityId/admin-panel/surveys/$surveyId/preview': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute
  '/community/$communityId/admin-panel/surveys/$surveyId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute
  '/community/$communityId/admin-panel/surveys/$surveyId/view': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute
  '/community/$communityId/project/$projectId/discussions/$discussionId/edit': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute
  '/community/$communityId/project/$projectId/request/edit/$requestId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute
  '/community/$communityId/tab/$tabId/entity/$entityId/network': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute
  '/community/$communityId/tab/$tabId/entity/$entityId/settings': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute
  '/community/$communityId/admin-panel/application-definitions/$applicationId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute
  '/community/$communityId/admin-panel/forms/application': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute
  '/community/$communityId/admin-panel/forms/evaluation': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute
  '/community/$communityId/admin-panel/forms/methodology': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute
  '/community/$communityId/admin-panel/forms/survey': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute
  '/community/$communityId/admin-panel/pages/$pageId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute
  '/community/$communityId/admin-panel/programs/$programId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute
  '/community/$communityId/admin-panel/surveys/$surveyId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute
  '/community/$communityId/project/$projectId/discussions/$discussionId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute
  '/community/$communityId/tab/$tabId/entity/$entityId': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute
  '/community/$communityId/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  '/community/$communityId/admin-panel/application-definitions/$applicationId/evaluate/$responseId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_unauth': typeof UnauthRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/_auth/_community': typeof AuthCommunityRouteWithChildren
  '/_auth/_project': typeof AuthProjectRouteWithChildren
  '/_auth/_super-admin': typeof AuthSuperAdminRouteWithChildren
  '/_auth/_user': typeof AuthUserRouteWithChildren
  '/_auth/application-definition': typeof AuthApplicationDefinitionRouteWithChildren
  '/_unauth/forgot-password': typeof UnauthForgotPasswordRoute
  '/_unauth/landing': typeof UnauthLandingRouteWithChildren
  '/_unauth/login': typeof UnauthLoginRoute
  '/_unauth/signup': typeof UnauthSignupRoute
  '/application-definition/$applicationDefinitionId': typeof ApplicationDefinitionApplicationDefinitionIdRouteWithChildren
  '/calendar-redirect/provider-google-meet': typeof CalendarRedirectProviderGoogleMeetRoute
  '/calendar-redirect/provider-msteams': typeof CalendarRedirectProviderMsteamsRoute
  '/calendar-redirect/provider-zoom': typeof CalendarRedirectProviderZoomRoute
  '/_auth/': typeof AuthIndexRoute
  '/calendar-redirect/': typeof CalendarRedirectIndexRoute
  '/_auth/_user/edit-profile': typeof AuthUserEditProfileRoute
  '/_auth/project/$projectId': typeof AuthProjectProjectIdRouteWithChildren
  '/_auth/request/accept-invitation': typeof AuthRequestAcceptInvitationRoute
  '/_auth/request/decline-invitation': typeof AuthRequestDeclineInvitationRoute
  '/_unauth/activate/$code': typeof UnauthActivateCodeRoute
  '/_unauth/reset-password/$activationCode': typeof UnauthResetPasswordActivationCodeRoute
  '/_unauth/landing/': typeof UnauthLandingIndexRoute
  '/_auth/_user/account/my-stuff': typeof AuthUserAccountMyStuffRoute
  '/_auth/_user/account/notification': typeof AuthUserAccountNotificationRoute
  '/_auth/_user/account/profile': typeof AuthUserAccountProfileRoute
  '/_auth/_user/account/settings': typeof AuthUserAccountSettingsRouteWithChildren
  '/_auth/_user/user/$userId': typeof AuthUserUserUserIdRoute
  '/_auth/community/$communityId/discussion': typeof AuthCommunityCommunityIdDiscussionRoute
  '/_auth/community/$communityId/members': typeof AuthCommunityCommunityIdMembersRoute
  '/_auth/community/$communityId/overview': typeof AuthCommunityCommunityIdOverviewRoute
  '/_auth/community/$entityId/accept-invitation': typeof AuthCommunityEntityIdAcceptInvitationRoute
  '/_auth/community/$entityId/decline-invitation': typeof AuthCommunityEntityIdDeclineInvitationRoute
  '/_auth/project/$entityId/accept-invitation': typeof AuthProjectEntityIdAcceptInvitationRoute
  '/_auth/project/$entityId/decline-invitation': typeof AuthProjectEntityIdDeclineInvitationRoute
  '/_auth/project/$projectId/business-model': typeof AuthProjectProjectIdBusinessModelRoute
  '/_auth/project/$projectId/discussion': typeof AuthProjectProjectIdDiscussionRouteWithChildren
  '/_auth/project/$projectId/kpis': typeof AuthProjectProjectIdKpisRoute
  '/_auth/project/$projectId/overview': typeof AuthProjectProjectIdOverviewRoute
  '/_auth/tab-entity/$entityId/accept-invitation': typeof AuthTabEntityEntityIdAcceptInvitationRoute
  '/_auth/tab-entity/$entityId/decline-invitation': typeof AuthTabEntityEntityIdDeclineInvitationRoute
  '/_unauth/activate/$activateAccountCode/$passwordCode': typeof UnauthActivateActivateAccountCodePasswordCodeRoute
  '/_unauth/landing/discussion/$discussionId': typeof UnauthLandingDiscussionDiscussionIdRoute
  '/_unauth/landing/entity/$entityId': typeof UnauthLandingEntityEntityIdRoute
  '/_unauth/landing/project/$projectId': typeof UnauthLandingProjectProjectIdRoute
  '/_unauth/landing/projects/$communityId': typeof UnauthLandingProjectsCommunityIdRoute
  '/_unauth/landing/request/$requestId': typeof UnauthLandingRequestRequestIdRoute
  '/_unauth/landing/tab/$tabId': typeof UnauthLandingTabTabIdRoute
  '/application-definition/$applicationDefinitionId/application/$applicationId': typeof ApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute
  '/application-definition/$applicationDefinitionId/application/create': typeof ApplicationDefinitionApplicationDefinitionIdApplicationCreateRoute
  '/application-definition/$applicationDefinitionId/application/new-application': typeof ApplicationDefinitionApplicationDefinitionIdApplicationNewApplicationRoute
  '/events/public/join/$token': typeof EventsPublicJoinTokenRoute
  '/_auth/_community/community/$communityId': typeof AuthCommunityCommunityCommunityIdRouteWithChildren
  '/_auth/_community/community/$communityId/_admin-panel': typeof AuthCommunityCommunityCommunityIdAdminPanelRouteWithChildren
  '/_auth/_community/community/$communityId/about': typeof AuthCommunityCommunityCommunityIdAboutRoute
  '/_auth/_community/community/$communityId/events': typeof AuthCommunityCommunityCommunityIdEventsRoute
  '/_auth/_community/community/$communityId/network': typeof AuthCommunityCommunityCommunityIdNetworkRoute
  '/_auth/_community/community/$communityId/requests': typeof AuthCommunityCommunityCommunityIdRequestsRoute
  '/_auth/_community/community/$communityId/resources': typeof AuthCommunityCommunityCommunityIdResourcesRoute
  '/_auth/_project/project/$projectId/business-model': typeof AuthProjectProjectProjectIdBusinessModelRoute
  '/_auth/_project/project/$projectId/kpis': typeof AuthProjectProjectProjectIdKpisRoute
  '/_auth/_project/project/$projectId/network': typeof AuthProjectProjectProjectIdNetworkRoute
  '/_auth/_project/project/$projectId/requests': typeof AuthProjectProjectProjectIdRequestsRoute
  '/_auth/_project/project/$projectId/resources': typeof AuthProjectProjectProjectIdResourcesRoute
  '/_auth/_project/project/$projectId/settings': typeof AuthProjectProjectProjectIdSettingsRoute
  '/_auth/_project/project/$projectId/surveys': typeof AuthProjectProjectProjectIdSurveysRoute
  '/_auth/_user/account/settings/provider-google-meet': typeof AuthUserAccountSettingsProviderGoogleMeetRoute
  '/_auth/_user/account/settings/provider-msteams': typeof AuthUserAccountSettingsProviderMsteamsRoute
  '/_auth/_user/account/settings/provider-zoom': typeof AuthUserAccountSettingsProviderZoomRoute
  '/_auth/application-definition/$appDefId/evaluate-application/$applicationId': typeof AuthApplicationDefinitionAppDefIdEvaluateApplicationApplicationIdRoute
  '/_auth/application-definition/$applicationDefinitionId/application/$applicationId': typeof AuthApplicationDefinitionApplicationDefinitionIdApplicationApplicationIdRoute
  '/_auth/project/$projectId/discussion/$discussionId': typeof AuthProjectProjectIdDiscussionDiscussionIdRoute
  '/_auth/_community/community/$communityId/': typeof AuthCommunityCommunityCommunityIdIndexRoute
  '/_auth/_project/project/$projectId/': typeof AuthProjectProjectProjectIdIndexRoute
  '/_auth/_super-admin/super-admin/communities/': typeof AuthSuperAdminSuperAdminCommunitiesIndexRoute
  '/_auth/_super-admin/super-admin/methodologies/': typeof AuthSuperAdminSuperAdminMethodologiesIndexRoute
  '/_auth/_super-admin/super-admin/projects/': typeof AuthSuperAdminSuperAdminProjectsIndexRoute
  '/_auth/_super-admin/super-admin/statistics/': typeof AuthSuperAdminSuperAdminStatisticsIndexRoute
  '/_auth/_super-admin/super-admin/users/': typeof AuthSuperAdminSuperAdminUsersIndexRoute
  '/_auth/_community/community/$communityId/discussions/new': typeof AuthCommunityCommunityCommunityIdDiscussionsNewRoute
  '/_auth/_community/community/$communityId/project/$projectId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRouteWithChildren
  '/_auth/_community/community/$communityId/project/create': typeof AuthCommunityCommunityCommunityIdProjectCreateRoute
  '/_auth/_project/project/$projectId/discussions/new': typeof AuthProjectProjectProjectIdDiscussionsNewRoute
  '/_auth/_project/project/$projectId/request/$requestId': typeof AuthProjectProjectProjectIdRequestRequestIdRoute
  '/_auth/_project/project/$projectId/request/new': typeof AuthProjectProjectProjectIdRequestNewRoute
  '/_auth/account/notifications/tab-entity/$entityId/accept-invitation': typeof AuthAccountNotificationsTabEntityEntityIdAcceptInvitationRoute
  '/_auth/account/notifications/tab-entity/$entityId/decline-invitation': typeof AuthAccountNotificationsTabEntityEntityIdDeclineInvitationRoute
  '/_auth/_community/community/$communityId/application-definitions/': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsIndexRoute
  '/_auth/_community/community/$communityId/discussions/': typeof AuthCommunityCommunityCommunityIdDiscussionsIndexRoute
  '/_auth/_community/community/$communityId/projects/': typeof AuthCommunityCommunityCommunityIdProjectsIndexRoute
  '/_auth/_community/community/$communityId/surveys/': typeof AuthCommunityCommunityCommunityIdSurveysIndexRoute
  '/_auth/_project/project/$projectId/discussions/': typeof AuthProjectProjectProjectIdDiscussionsIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCommunitySettingsRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelEventSettingsRoute
  '/_auth/_community/community/$communityId/application-definition-group/$groupId/responses': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdResponsesRoute
  '/_auth/_community/community/$communityId/application-definitions/$applicationId/responses': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdResponsesRoute
  '/_auth/_community/community/$communityId/discussions/$discussionId/edit': typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdEditRoute
  '/_auth/_community/community/$communityId/project/$projectId/business-model': typeof AuthCommunityCommunityCommunityIdProjectProjectIdBusinessModelRoute
  '/_auth/_community/community/$communityId/project/$projectId/kpis': typeof AuthCommunityCommunityCommunityIdProjectProjectIdKpisRoute
  '/_auth/_community/community/$communityId/project/$projectId/network': typeof AuthCommunityCommunityCommunityIdProjectProjectIdNetworkRoute
  '/_auth/_community/community/$communityId/project/$projectId/requests': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestsRoute
  '/_auth/_community/community/$communityId/project/$projectId/resources': typeof AuthCommunityCommunityCommunityIdProjectProjectIdResourcesRoute
  '/_auth/_community/community/$communityId/project/$projectId/settings': typeof AuthCommunityCommunityCommunityIdProjectProjectIdSettingsRoute
  '/_auth/_community/community/$communityId/project/$projectId/surveys': typeof AuthCommunityCommunityCommunityIdProjectProjectIdSurveysRoute
  '/_auth/_community/community/$communityId/surveys/$surveyId/complete': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdCompleteRoute
  '/_auth/_community/community/$communityId/surveys/$surveyId/responses': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdResponsesRoute
  '/_auth/_community/community/$communityId/surveys/$surveyId/view': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdViewRoute
  '/_auth/_project/project/$projectId/discussions/$discussionId/edit': typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdEditRoute
  '/_auth/_project/project/$projectId/request/edit/$requestId': typeof AuthProjectProjectProjectIdRequestEditRequestIdRoute
  '/_auth/community/$communityId/application-definition/$appDefId/evaluate/$applicationId': typeof AuthCommunityCommunityIdApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
  '/_auth/_community/community/$communityId/discussions/$discussionId/': typeof AuthCommunityCommunityCommunityIdDiscussionsDiscussionIdIndexRoute
  '/_auth/_community/community/$communityId/project/$projectId/': typeof AuthCommunityCommunityCommunityIdProjectProjectIdIndexRoute
  '/_auth/_community/community/$communityId/tab/$tabId/': typeof AuthCommunityCommunityCommunityIdTabTabIdIndexRoute
  '/_auth/_project/project/$projectId/discussions/$discussionId/': typeof AuthProjectProjectProjectIdDiscussionsDiscussionIdIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsCreateRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesCreateRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsCreateRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysCreateRoute
  '/_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  '/_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate/$responseId': typeof AuthCommunityCommunityCommunityIdApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
  '/_auth/_community/community/$communityId/project/$projectId/discussions/new': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsNewRoute
  '/_auth/_community/community/$communityId/project/$projectId/request/$requestId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestRequestIdRoute
  '/_auth/_community/community/$communityId/project/$projectId/request/new': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestNewRoute
  '/_auth/_community/community/$communityId/surveys/$surveyId/answers/$responseId': typeof AuthCommunityCommunityCommunityIdSurveysSurveyIdAnswersResponseIdRoute
  '/_auth/_community/community/$communityId/tab/$tabId/entity/create': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityCreateRoute
  '/_auth/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId': typeof AuthCommunityCommunityIdAdminPanelApplicationDefinitionAppDefIdEvaluateApplicationIdRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelActivityFeedIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelCircleManagementIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelOverviewProjectsIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelRequestsStatusIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupKpisIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStartupsProgressIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelStatisticsIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/users/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelUsersIndexRoute
  '/_auth/_community/community/$communityId/project/$projectId/discussions/': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdResponsesRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdResponsesRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationFormIdRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationCreateRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationFormIdRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationCreateRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyFormIdRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyCreateRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyFormIdRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyCreateRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdKpisRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPeopleRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdPlannerRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdPreviewRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdResponsesRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdViewRoute
  '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdEditRoute
  '/_auth/_community/community/$communityId/project/$projectId/request/edit/$requestId': typeof AuthCommunityCommunityCommunityIdProjectProjectIdRequestEditRequestIdRoute
  '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdNetworkRoute
  '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdSettingsRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsApplicationIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsEvaluationIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsMethodologyIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelFormsSurveyIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelPagesPageIdIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelProgramsProgramIdIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelSurveysSurveyIdIndexRoute
  '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/': typeof AuthCommunityCommunityCommunityIdProjectProjectIdDiscussionsDiscussionIdIndexRoute
  '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/': typeof AuthCommunityCommunityCommunityIdTabTabIdEntityEntityIdIndexRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionGroupGroupIdEvaluateRoundsApplicationResponseGroupIdRoute
  '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate/$responseId': typeof AuthCommunityCommunityCommunityIdAdminPanelAdminPanelApplicationDefinitionsApplicationIdEvaluateResponseIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/sso-callback'
    | '/application-definition'
    | '/forgot-password'
    | '/landing'
    | '/login'
    | '/signup'
    | '/application-definition/$applicationDefinitionId'
    | '/calendar-redirect/provider-google-meet'
    | '/calendar-redirect/provider-msteams'
    | '/calendar-redirect/provider-zoom'
    | '/'
    | '/calendar-redirect'
    | '/edit-profile'
    | '/project/$projectId'
    | '/request/accept-invitation'
    | '/request/decline-invitation'
    | '/activate/$code'
    | '/reset-password/$activationCode'
    | '/landing/'
    | '/account/my-stuff'
    | '/account/notification'
    | '/account/profile'
    | '/account/settings'
    | '/user/$userId'
    | '/community/$communityId/discussion'
    | '/community/$communityId/members'
    | '/community/$communityId/overview'
    | '/community/$entityId/accept-invitation'
    | '/community/$entityId/decline-invitation'
    | '/project/$entityId/accept-invitation'
    | '/project/$entityId/decline-invitation'
    | '/project/$projectId/business-model'
    | '/project/$projectId/discussion'
    | '/project/$projectId/kpis'
    | '/project/$projectId/overview'
    | '/tab-entity/$entityId/accept-invitation'
    | '/tab-entity/$entityId/decline-invitation'
    | '/activate/$activateAccountCode/$passwordCode'
    | '/landing/discussion/$discussionId'
    | '/landing/entity/$entityId'
    | '/landing/project/$projectId'
    | '/landing/projects/$communityId'
    | '/landing/request/$requestId'
    | '/landing/tab/$tabId'
    | '/application-definition/$applicationDefinitionId/application/$applicationId'
    | '/application-definition/$applicationDefinitionId/application/create'
    | '/application-definition/$applicationDefinitionId/application/new-application'
    | '/events/public/join/$token'
    | '/community/$communityId'
    | '/community/$communityId/about'
    | '/community/$communityId/events'
    | '/community/$communityId/network'
    | '/community/$communityId/requests'
    | '/community/$communityId/resources'
    | '/project/$projectId/network'
    | '/project/$projectId/requests'
    | '/project/$projectId/resources'
    | '/project/$projectId/settings'
    | '/project/$projectId/surveys'
    | '/account/settings/provider-google-meet'
    | '/account/settings/provider-msteams'
    | '/account/settings/provider-zoom'
    | '/application-definition/$appDefId/evaluate-application/$applicationId'
    | '/project/$projectId/discussion/$discussionId'
    | '/community/$communityId/'
    | '/super-admin/communities'
    | '/super-admin/methodologies'
    | '/super-admin/projects'
    | '/super-admin/statistics'
    | '/super-admin/users'
    | '/community/$communityId/discussions/new'
    | '/community/$communityId/project/$projectId'
    | '/community/$communityId/project/create'
    | '/project/$projectId/discussions/new'
    | '/project/$projectId/request/$requestId'
    | '/project/$projectId/request/new'
    | '/account/notifications/tab-entity/$entityId/accept-invitation'
    | '/account/notifications/tab-entity/$entityId/decline-invitation'
    | '/community/$communityId/application-definitions'
    | '/community/$communityId/discussions'
    | '/community/$communityId/projects'
    | '/community/$communityId/surveys'
    | '/project/$projectId/discussions'
    | '/community/$communityId/admin-panel/community-settings'
    | '/community/$communityId/admin-panel/event-settings'
    | '/community/$communityId/application-definition-group/$groupId/responses'
    | '/community/$communityId/application-definitions/$applicationId/responses'
    | '/community/$communityId/discussions/$discussionId/edit'
    | '/community/$communityId/project/$projectId/business-model'
    | '/community/$communityId/project/$projectId/kpis'
    | '/community/$communityId/project/$projectId/network'
    | '/community/$communityId/project/$projectId/requests'
    | '/community/$communityId/project/$projectId/resources'
    | '/community/$communityId/project/$projectId/settings'
    | '/community/$communityId/project/$projectId/surveys'
    | '/community/$communityId/surveys/$surveyId/complete'
    | '/community/$communityId/surveys/$surveyId/responses'
    | '/community/$communityId/surveys/$surveyId/view'
    | '/project/$projectId/discussions/$discussionId/edit'
    | '/project/$projectId/request/edit/$requestId'
    | '/community/$communityId/application-definition/$appDefId/evaluate/$applicationId'
    | '/community/$communityId/discussions/$discussionId'
    | '/community/$communityId/project/$projectId/'
    | '/community/$communityId/tab/$tabId'
    | '/project/$projectId/discussions/$discussionId'
    | '/community/$communityId/admin-panel/application-definitions/create'
    | '/community/$communityId/admin-panel/pages/create'
    | '/community/$communityId/admin-panel/programs/create'
    | '/community/$communityId/admin-panel/surveys/create'
    | '/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
    | '/community/$communityId/application-definitions/$applicationId/evaluate/$responseId'
    | '/community/$communityId/project/$projectId/discussions/new'
    | '/community/$communityId/project/$projectId/request/$requestId'
    | '/community/$communityId/project/$projectId/request/new'
    | '/community/$communityId/surveys/$surveyId/answers/$responseId'
    | '/community/$communityId/tab/$tabId/entity/create'
    | '/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId'
    | '/community/$communityId/admin-panel/activity-feed'
    | '/community/$communityId/admin-panel/application-definitions'
    | '/community/$communityId/admin-panel/circle-management'
    | '/community/$communityId/admin-panel/overview-projects'
    | '/community/$communityId/admin-panel/pages'
    | '/community/$communityId/admin-panel/programs'
    | '/community/$communityId/admin-panel/requests-status'
    | '/community/$communityId/admin-panel/startup-kpis'
    | '/community/$communityId/admin-panel/startups-progress'
    | '/community/$communityId/admin-panel/statistics'
    | '/community/$communityId/admin-panel/surveys'
    | '/community/$communityId/admin-panel/users'
    | '/community/$communityId/project/$projectId/discussions'
    | '/community/$communityId/admin-panel/application-definition-group/$groupId/responses'
    | '/community/$communityId/admin-panel/application-definitions/$applicationId/responses'
    | '/community/$communityId/admin-panel/forms/application/$formId'
    | '/community/$communityId/admin-panel/forms/application/create'
    | '/community/$communityId/admin-panel/forms/evaluation/$formId'
    | '/community/$communityId/admin-panel/forms/evaluation/create'
    | '/community/$communityId/admin-panel/forms/methodology/$formId'
    | '/community/$communityId/admin-panel/forms/methodology/create'
    | '/community/$communityId/admin-panel/forms/survey/$formId'
    | '/community/$communityId/admin-panel/forms/survey/create'
    | '/community/$communityId/admin-panel/programs/$programId/kpis'
    | '/community/$communityId/admin-panel/programs/$programId/people'
    | '/community/$communityId/admin-panel/programs/$programId/planner'
    | '/community/$communityId/admin-panel/surveys/$surveyId/preview'
    | '/community/$communityId/admin-panel/surveys/$surveyId/responses'
    | '/community/$communityId/admin-panel/surveys/$surveyId/view'
    | '/community/$communityId/project/$projectId/discussions/$discussionId/edit'
    | '/community/$communityId/project/$projectId/request/edit/$requestId'
    | '/community/$communityId/tab/$tabId/entity/$entityId/network'
    | '/community/$communityId/tab/$tabId/entity/$entityId/settings'
    | '/community/$communityId/admin-panel/application-definitions/$applicationId'
    | '/community/$communityId/admin-panel/forms/application'
    | '/community/$communityId/admin-panel/forms/evaluation'
    | '/community/$communityId/admin-panel/forms/methodology'
    | '/community/$communityId/admin-panel/forms/survey'
    | '/community/$communityId/admin-panel/pages/$pageId'
    | '/community/$communityId/admin-panel/programs/$programId'
    | '/community/$communityId/admin-panel/surveys/$surveyId'
    | '/community/$communityId/project/$projectId/discussions/$discussionId'
    | '/community/$communityId/tab/$tabId/entity/$entityId'
    | '/community/$communityId/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
    | '/community/$communityId/admin-panel/application-definitions/$applicationId/evaluate/$responseId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/sso-callback'
    | '/application-definition'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/application-definition/$applicationDefinitionId'
    | '/calendar-redirect/provider-google-meet'
    | '/calendar-redirect/provider-msteams'
    | '/calendar-redirect/provider-zoom'
    | '/'
    | '/calendar-redirect'
    | '/edit-profile'
    | '/project/$projectId'
    | '/request/accept-invitation'
    | '/request/decline-invitation'
    | '/activate/$code'
    | '/reset-password/$activationCode'
    | '/landing'
    | '/account/my-stuff'
    | '/account/notification'
    | '/account/profile'
    | '/account/settings'
    | '/user/$userId'
    | '/community/$communityId/discussion'
    | '/community/$communityId/members'
    | '/community/$communityId/overview'
    | '/community/$entityId/accept-invitation'
    | '/community/$entityId/decline-invitation'
    | '/project/$entityId/accept-invitation'
    | '/project/$entityId/decline-invitation'
    | '/project/$projectId/business-model'
    | '/project/$projectId/discussion'
    | '/project/$projectId/kpis'
    | '/project/$projectId/overview'
    | '/tab-entity/$entityId/accept-invitation'
    | '/tab-entity/$entityId/decline-invitation'
    | '/activate/$activateAccountCode/$passwordCode'
    | '/landing/discussion/$discussionId'
    | '/landing/entity/$entityId'
    | '/landing/project/$projectId'
    | '/landing/projects/$communityId'
    | '/landing/request/$requestId'
    | '/landing/tab/$tabId'
    | '/application-definition/$applicationDefinitionId/application/$applicationId'
    | '/application-definition/$applicationDefinitionId/application/create'
    | '/application-definition/$applicationDefinitionId/application/new-application'
    | '/events/public/join/$token'
    | '/community/$communityId'
    | '/community/$communityId/about'
    | '/community/$communityId/events'
    | '/community/$communityId/network'
    | '/community/$communityId/requests'
    | '/community/$communityId/resources'
    | '/project/$projectId/network'
    | '/project/$projectId/requests'
    | '/project/$projectId/resources'
    | '/project/$projectId/settings'
    | '/project/$projectId/surveys'
    | '/account/settings/provider-google-meet'
    | '/account/settings/provider-msteams'
    | '/account/settings/provider-zoom'
    | '/application-definition/$appDefId/evaluate-application/$applicationId'
    | '/project/$projectId/discussion/$discussionId'
    | '/super-admin/communities'
    | '/super-admin/methodologies'
    | '/super-admin/projects'
    | '/super-admin/statistics'
    | '/super-admin/users'
    | '/community/$communityId/discussions/new'
    | '/community/$communityId/project/create'
    | '/project/$projectId/discussions/new'
    | '/project/$projectId/request/$requestId'
    | '/project/$projectId/request/new'
    | '/account/notifications/tab-entity/$entityId/accept-invitation'
    | '/account/notifications/tab-entity/$entityId/decline-invitation'
    | '/community/$communityId/application-definitions'
    | '/community/$communityId/discussions'
    | '/community/$communityId/projects'
    | '/community/$communityId/surveys'
    | '/project/$projectId/discussions'
    | '/community/$communityId/admin-panel/community-settings'
    | '/community/$communityId/admin-panel/event-settings'
    | '/community/$communityId/application-definition-group/$groupId/responses'
    | '/community/$communityId/application-definitions/$applicationId/responses'
    | '/community/$communityId/discussions/$discussionId/edit'
    | '/community/$communityId/project/$projectId/business-model'
    | '/community/$communityId/project/$projectId/kpis'
    | '/community/$communityId/project/$projectId/network'
    | '/community/$communityId/project/$projectId/requests'
    | '/community/$communityId/project/$projectId/resources'
    | '/community/$communityId/project/$projectId/settings'
    | '/community/$communityId/project/$projectId/surveys'
    | '/community/$communityId/surveys/$surveyId/complete'
    | '/community/$communityId/surveys/$surveyId/responses'
    | '/community/$communityId/surveys/$surveyId/view'
    | '/project/$projectId/discussions/$discussionId/edit'
    | '/project/$projectId/request/edit/$requestId'
    | '/community/$communityId/application-definition/$appDefId/evaluate/$applicationId'
    | '/community/$communityId/discussions/$discussionId'
    | '/community/$communityId/project/$projectId'
    | '/community/$communityId/tab/$tabId'
    | '/project/$projectId/discussions/$discussionId'
    | '/community/$communityId/admin-panel/application-definitions/create'
    | '/community/$communityId/admin-panel/pages/create'
    | '/community/$communityId/admin-panel/programs/create'
    | '/community/$communityId/admin-panel/surveys/create'
    | '/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
    | '/community/$communityId/application-definitions/$applicationId/evaluate/$responseId'
    | '/community/$communityId/project/$projectId/discussions/new'
    | '/community/$communityId/project/$projectId/request/$requestId'
    | '/community/$communityId/project/$projectId/request/new'
    | '/community/$communityId/surveys/$surveyId/answers/$responseId'
    | '/community/$communityId/tab/$tabId/entity/create'
    | '/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId'
    | '/community/$communityId/admin-panel/activity-feed'
    | '/community/$communityId/admin-panel/application-definitions'
    | '/community/$communityId/admin-panel/circle-management'
    | '/community/$communityId/admin-panel/overview-projects'
    | '/community/$communityId/admin-panel/pages'
    | '/community/$communityId/admin-panel/programs'
    | '/community/$communityId/admin-panel/requests-status'
    | '/community/$communityId/admin-panel/startup-kpis'
    | '/community/$communityId/admin-panel/startups-progress'
    | '/community/$communityId/admin-panel/statistics'
    | '/community/$communityId/admin-panel/surveys'
    | '/community/$communityId/admin-panel/users'
    | '/community/$communityId/project/$projectId/discussions'
    | '/community/$communityId/admin-panel/application-definition-group/$groupId/responses'
    | '/community/$communityId/admin-panel/application-definitions/$applicationId/responses'
    | '/community/$communityId/admin-panel/forms/application/$formId'
    | '/community/$communityId/admin-panel/forms/application/create'
    | '/community/$communityId/admin-panel/forms/evaluation/$formId'
    | '/community/$communityId/admin-panel/forms/evaluation/create'
    | '/community/$communityId/admin-panel/forms/methodology/$formId'
    | '/community/$communityId/admin-panel/forms/methodology/create'
    | '/community/$communityId/admin-panel/forms/survey/$formId'
    | '/community/$communityId/admin-panel/forms/survey/create'
    | '/community/$communityId/admin-panel/programs/$programId/kpis'
    | '/community/$communityId/admin-panel/programs/$programId/people'
    | '/community/$communityId/admin-panel/programs/$programId/planner'
    | '/community/$communityId/admin-panel/surveys/$surveyId/preview'
    | '/community/$communityId/admin-panel/surveys/$surveyId/responses'
    | '/community/$communityId/admin-panel/surveys/$surveyId/view'
    | '/community/$communityId/project/$projectId/discussions/$discussionId/edit'
    | '/community/$communityId/project/$projectId/request/edit/$requestId'
    | '/community/$communityId/tab/$tabId/entity/$entityId/network'
    | '/community/$communityId/tab/$tabId/entity/$entityId/settings'
    | '/community/$communityId/admin-panel/application-definitions/$applicationId'
    | '/community/$communityId/admin-panel/forms/application'
    | '/community/$communityId/admin-panel/forms/evaluation'
    | '/community/$communityId/admin-panel/forms/methodology'
    | '/community/$communityId/admin-panel/forms/survey'
    | '/community/$communityId/admin-panel/pages/$pageId'
    | '/community/$communityId/admin-panel/programs/$programId'
    | '/community/$communityId/admin-panel/surveys/$surveyId'
    | '/community/$communityId/project/$projectId/discussions/$discussionId'
    | '/community/$communityId/tab/$tabId/entity/$entityId'
    | '/community/$communityId/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
    | '/community/$communityId/admin-panel/application-definitions/$applicationId/evaluate/$responseId'
  id:
    | '__root__'
    | '/_auth'
    | '/_unauth'
    | '/sso-callback'
    | '/_auth/_community'
    | '/_auth/_project'
    | '/_auth/_super-admin'
    | '/_auth/_user'
    | '/_auth/application-definition'
    | '/_unauth/forgot-password'
    | '/_unauth/landing'
    | '/_unauth/login'
    | '/_unauth/signup'
    | '/application-definition/$applicationDefinitionId'
    | '/calendar-redirect/provider-google-meet'
    | '/calendar-redirect/provider-msteams'
    | '/calendar-redirect/provider-zoom'
    | '/_auth/'
    | '/calendar-redirect/'
    | '/_auth/_user/edit-profile'
    | '/_auth/project/$projectId'
    | '/_auth/request/accept-invitation'
    | '/_auth/request/decline-invitation'
    | '/_unauth/activate/$code'
    | '/_unauth/reset-password/$activationCode'
    | '/_unauth/landing/'
    | '/_auth/_user/account/my-stuff'
    | '/_auth/_user/account/notification'
    | '/_auth/_user/account/profile'
    | '/_auth/_user/account/settings'
    | '/_auth/_user/user/$userId'
    | '/_auth/community/$communityId/discussion'
    | '/_auth/community/$communityId/members'
    | '/_auth/community/$communityId/overview'
    | '/_auth/community/$entityId/accept-invitation'
    | '/_auth/community/$entityId/decline-invitation'
    | '/_auth/project/$entityId/accept-invitation'
    | '/_auth/project/$entityId/decline-invitation'
    | '/_auth/project/$projectId/business-model'
    | '/_auth/project/$projectId/discussion'
    | '/_auth/project/$projectId/kpis'
    | '/_auth/project/$projectId/overview'
    | '/_auth/tab-entity/$entityId/accept-invitation'
    | '/_auth/tab-entity/$entityId/decline-invitation'
    | '/_unauth/activate/$activateAccountCode/$passwordCode'
    | '/_unauth/landing/discussion/$discussionId'
    | '/_unauth/landing/entity/$entityId'
    | '/_unauth/landing/project/$projectId'
    | '/_unauth/landing/projects/$communityId'
    | '/_unauth/landing/request/$requestId'
    | '/_unauth/landing/tab/$tabId'
    | '/application-definition/$applicationDefinitionId/application/$applicationId'
    | '/application-definition/$applicationDefinitionId/application/create'
    | '/application-definition/$applicationDefinitionId/application/new-application'
    | '/events/public/join/$token'
    | '/_auth/_community/community/$communityId'
    | '/_auth/_community/community/$communityId/_admin-panel'
    | '/_auth/_community/community/$communityId/about'
    | '/_auth/_community/community/$communityId/events'
    | '/_auth/_community/community/$communityId/network'
    | '/_auth/_community/community/$communityId/requests'
    | '/_auth/_community/community/$communityId/resources'
    | '/_auth/_project/project/$projectId/business-model'
    | '/_auth/_project/project/$projectId/kpis'
    | '/_auth/_project/project/$projectId/network'
    | '/_auth/_project/project/$projectId/requests'
    | '/_auth/_project/project/$projectId/resources'
    | '/_auth/_project/project/$projectId/settings'
    | '/_auth/_project/project/$projectId/surveys'
    | '/_auth/_user/account/settings/provider-google-meet'
    | '/_auth/_user/account/settings/provider-msteams'
    | '/_auth/_user/account/settings/provider-zoom'
    | '/_auth/application-definition/$appDefId/evaluate-application/$applicationId'
    | '/_auth/application-definition/$applicationDefinitionId/application/$applicationId'
    | '/_auth/project/$projectId/discussion/$discussionId'
    | '/_auth/_community/community/$communityId/'
    | '/_auth/_project/project/$projectId/'
    | '/_auth/_super-admin/super-admin/communities/'
    | '/_auth/_super-admin/super-admin/methodologies/'
    | '/_auth/_super-admin/super-admin/projects/'
    | '/_auth/_super-admin/super-admin/statistics/'
    | '/_auth/_super-admin/super-admin/users/'
    | '/_auth/_community/community/$communityId/discussions/new'
    | '/_auth/_community/community/$communityId/project/$projectId'
    | '/_auth/_community/community/$communityId/project/create'
    | '/_auth/_project/project/$projectId/discussions/new'
    | '/_auth/_project/project/$projectId/request/$requestId'
    | '/_auth/_project/project/$projectId/request/new'
    | '/_auth/account/notifications/tab-entity/$entityId/accept-invitation'
    | '/_auth/account/notifications/tab-entity/$entityId/decline-invitation'
    | '/_auth/_community/community/$communityId/application-definitions/'
    | '/_auth/_community/community/$communityId/discussions/'
    | '/_auth/_community/community/$communityId/projects/'
    | '/_auth/_community/community/$communityId/surveys/'
    | '/_auth/_project/project/$projectId/discussions/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings'
    | '/_auth/_community/community/$communityId/application-definition-group/$groupId/responses'
    | '/_auth/_community/community/$communityId/application-definitions/$applicationId/responses'
    | '/_auth/_community/community/$communityId/discussions/$discussionId/edit'
    | '/_auth/_community/community/$communityId/project/$projectId/business-model'
    | '/_auth/_community/community/$communityId/project/$projectId/kpis'
    | '/_auth/_community/community/$communityId/project/$projectId/network'
    | '/_auth/_community/community/$communityId/project/$projectId/requests'
    | '/_auth/_community/community/$communityId/project/$projectId/resources'
    | '/_auth/_community/community/$communityId/project/$projectId/settings'
    | '/_auth/_community/community/$communityId/project/$projectId/surveys'
    | '/_auth/_community/community/$communityId/surveys/$surveyId/complete'
    | '/_auth/_community/community/$communityId/surveys/$surveyId/responses'
    | '/_auth/_community/community/$communityId/surveys/$surveyId/view'
    | '/_auth/_project/project/$projectId/discussions/$discussionId/edit'
    | '/_auth/_project/project/$projectId/request/edit/$requestId'
    | '/_auth/community/$communityId/application-definition/$appDefId/evaluate/$applicationId'
    | '/_auth/_community/community/$communityId/discussions/$discussionId/'
    | '/_auth/_community/community/$communityId/project/$projectId/'
    | '/_auth/_community/community/$communityId/tab/$tabId/'
    | '/_auth/_project/project/$projectId/discussions/$discussionId/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create'
    | '/_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
    | '/_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate/$responseId'
    | '/_auth/_community/community/$communityId/project/$projectId/discussions/new'
    | '/_auth/_community/community/$communityId/project/$projectId/request/$requestId'
    | '/_auth/_community/community/$communityId/project/$projectId/request/new'
    | '/_auth/_community/community/$communityId/surveys/$surveyId/answers/$responseId'
    | '/_auth/_community/community/$communityId/tab/$tabId/entity/create'
    | '/_auth/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/users/'
    | '/_auth/_community/community/$communityId/project/$projectId/discussions/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view'
    | '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit'
    | '/_auth/_community/community/$communityId/project/$projectId/request/edit/$requestId'
    | '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network'
    | '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/'
    | '/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/'
    | '/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId'
    | '/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate/$responseId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  UnauthRoute: typeof UnauthRouteWithChildren
  SsoCallbackRoute: typeof SsoCallbackRoute
  ApplicationDefinitionApplicationDefinitionIdRoute: typeof ApplicationDefinitionApplicationDefinitionIdRouteWithChildren
  CalendarRedirectProviderGoogleMeetRoute: typeof CalendarRedirectProviderGoogleMeetRoute
  CalendarRedirectProviderMsteamsRoute: typeof CalendarRedirectProviderMsteamsRoute
  CalendarRedirectProviderZoomRoute: typeof CalendarRedirectProviderZoomRoute
  CalendarRedirectIndexRoute: typeof CalendarRedirectIndexRoute
  EventsPublicJoinTokenRoute: typeof EventsPublicJoinTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  UnauthRoute: UnauthRouteWithChildren,
  SsoCallbackRoute: SsoCallbackRoute,
  ApplicationDefinitionApplicationDefinitionIdRoute:
    ApplicationDefinitionApplicationDefinitionIdRouteWithChildren,
  CalendarRedirectProviderGoogleMeetRoute:
    CalendarRedirectProviderGoogleMeetRoute,
  CalendarRedirectProviderMsteamsRoute: CalendarRedirectProviderMsteamsRoute,
  CalendarRedirectProviderZoomRoute: CalendarRedirectProviderZoomRoute,
  CalendarRedirectIndexRoute: CalendarRedirectIndexRoute,
  EventsPublicJoinTokenRoute: EventsPublicJoinTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_unauth",
        "/sso-callback",
        "/application-definition/$applicationDefinitionId",
        "/calendar-redirect/provider-google-meet",
        "/calendar-redirect/provider-msteams",
        "/calendar-redirect/provider-zoom",
        "/calendar-redirect/",
        "/events/public/join/$token"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/_community",
        "/_auth/_project",
        "/_auth/_super-admin",
        "/_auth/_user",
        "/_auth/application-definition",
        "/_auth/",
        "/_auth/project/$projectId",
        "/_auth/request/accept-invitation",
        "/_auth/request/decline-invitation",
        "/_auth/community/$communityId/discussion",
        "/_auth/community/$communityId/members",
        "/_auth/community/$communityId/overview",
        "/_auth/community/$entityId/accept-invitation",
        "/_auth/community/$entityId/decline-invitation",
        "/_auth/project/$entityId/accept-invitation",
        "/_auth/project/$entityId/decline-invitation",
        "/_auth/tab-entity/$entityId/accept-invitation",
        "/_auth/tab-entity/$entityId/decline-invitation",
        "/_auth/account/notifications/tab-entity/$entityId/accept-invitation",
        "/_auth/account/notifications/tab-entity/$entityId/decline-invitation",
        "/_auth/community/$communityId/application-definition/$appDefId/evaluate/$applicationId",
        "/_auth/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId"
      ]
    },
    "/_unauth": {
      "filePath": "_unauth.tsx",
      "children": [
        "/_unauth/forgot-password",
        "/_unauth/landing",
        "/_unauth/login",
        "/_unauth/signup",
        "/_unauth/activate/$code",
        "/_unauth/reset-password/$activationCode",
        "/_unauth/activate/$activateAccountCode/$passwordCode"
      ]
    },
    "/sso-callback": {
      "filePath": "sso-callback.tsx"
    },
    "/_auth/_community": {
      "filePath": "_auth/_community.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_community/community/$communityId"
      ]
    },
    "/_auth/_project": {
      "filePath": "_auth/_project.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_project/project/$projectId/business-model",
        "/_auth/_project/project/$projectId/kpis",
        "/_auth/_project/project/$projectId/network",
        "/_auth/_project/project/$projectId/requests",
        "/_auth/_project/project/$projectId/resources",
        "/_auth/_project/project/$projectId/settings",
        "/_auth/_project/project/$projectId/surveys",
        "/_auth/_project/project/$projectId/",
        "/_auth/_project/project/$projectId/discussions/new",
        "/_auth/_project/project/$projectId/request/$requestId",
        "/_auth/_project/project/$projectId/request/new",
        "/_auth/_project/project/$projectId/discussions/",
        "/_auth/_project/project/$projectId/discussions/$discussionId/edit",
        "/_auth/_project/project/$projectId/request/edit/$requestId",
        "/_auth/_project/project/$projectId/discussions/$discussionId/"
      ]
    },
    "/_auth/_super-admin": {
      "filePath": "_auth/_super-admin.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_super-admin/super-admin/communities/",
        "/_auth/_super-admin/super-admin/methodologies/",
        "/_auth/_super-admin/super-admin/projects/",
        "/_auth/_super-admin/super-admin/statistics/",
        "/_auth/_super-admin/super-admin/users/"
      ]
    },
    "/_auth/_user": {
      "filePath": "_auth/_user.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_user/edit-profile",
        "/_auth/_user/account/my-stuff",
        "/_auth/_user/account/notification",
        "/_auth/_user/account/profile",
        "/_auth/_user/account/settings",
        "/_auth/_user/user/$userId"
      ]
    },
    "/_auth/application-definition": {
      "filePath": "_auth/application-definition.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/application-definition/$appDefId/evaluate-application/$applicationId",
        "/_auth/application-definition/$applicationDefinitionId/application/$applicationId"
      ]
    },
    "/_unauth/forgot-password": {
      "filePath": "_unauth.forgot-password.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/landing": {
      "filePath": "_unauth.landing.tsx",
      "parent": "/_unauth",
      "children": [
        "/_unauth/landing/",
        "/_unauth/landing/discussion/$discussionId",
        "/_unauth/landing/entity/$entityId",
        "/_unauth/landing/project/$projectId",
        "/_unauth/landing/projects/$communityId",
        "/_unauth/landing/request/$requestId",
        "/_unauth/landing/tab/$tabId"
      ]
    },
    "/_unauth/login": {
      "filePath": "_unauth.login.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/signup": {
      "filePath": "_unauth.signup.tsx",
      "parent": "/_unauth"
    },
    "/application-definition/$applicationDefinitionId": {
      "filePath": "application-definition/$applicationDefinitionId.tsx",
      "children": [
        "/application-definition/$applicationDefinitionId/application/$applicationId",
        "/application-definition/$applicationDefinitionId/application/create",
        "/application-definition/$applicationDefinitionId/application/new-application"
      ]
    },
    "/calendar-redirect/provider-google-meet": {
      "filePath": "calendar-redirect/provider-google-meet.tsx"
    },
    "/calendar-redirect/provider-msteams": {
      "filePath": "calendar-redirect/provider-msteams.tsx"
    },
    "/calendar-redirect/provider-zoom": {
      "filePath": "calendar-redirect/provider-zoom.tsx"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    },
    "/calendar-redirect/": {
      "filePath": "calendar-redirect/index.tsx"
    },
    "/_auth/_user/edit-profile": {
      "filePath": "_auth/_user/edit-profile.tsx",
      "parent": "/_auth/_user"
    },
    "/_auth/project/$projectId": {
      "filePath": "_auth/project.$projectId.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/project/$projectId/business-model",
        "/_auth/project/$projectId/discussion",
        "/_auth/project/$projectId/kpis",
        "/_auth/project/$projectId/overview"
      ]
    },
    "/_auth/request/accept-invitation": {
      "filePath": "_auth/request.accept-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/request/decline-invitation": {
      "filePath": "_auth/request.decline-invitation.tsx",
      "parent": "/_auth"
    },
    "/_unauth/activate/$code": {
      "filePath": "_unauth.activate.$code.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/reset-password/$activationCode": {
      "filePath": "_unauth.reset-password.$activationCode.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/landing/": {
      "filePath": "_unauth.landing.index.tsx",
      "parent": "/_unauth/landing"
    },
    "/_auth/_user/account/my-stuff": {
      "filePath": "_auth/_user/account.my-stuff.tsx",
      "parent": "/_auth/_user"
    },
    "/_auth/_user/account/notification": {
      "filePath": "_auth/_user/account.notification.tsx",
      "parent": "/_auth/_user"
    },
    "/_auth/_user/account/profile": {
      "filePath": "_auth/_user/account.profile.tsx",
      "parent": "/_auth/_user"
    },
    "/_auth/_user/account/settings": {
      "filePath": "_auth/_user/account.settings.tsx",
      "parent": "/_auth/_user",
      "children": [
        "/_auth/_user/account/settings/provider-google-meet",
        "/_auth/_user/account/settings/provider-msteams",
        "/_auth/_user/account/settings/provider-zoom"
      ]
    },
    "/_auth/_user/user/$userId": {
      "filePath": "_auth/_user/user/$userId.tsx",
      "parent": "/_auth/_user"
    },
    "/_auth/community/$communityId/discussion": {
      "filePath": "_auth/community.$communityId.discussion.tsx",
      "parent": "/_auth"
    },
    "/_auth/community/$communityId/members": {
      "filePath": "_auth/community.$communityId.members.tsx",
      "parent": "/_auth"
    },
    "/_auth/community/$communityId/overview": {
      "filePath": "_auth/community.$communityId.overview.tsx",
      "parent": "/_auth"
    },
    "/_auth/community/$entityId/accept-invitation": {
      "filePath": "_auth/community.$entityId.accept-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/community/$entityId/decline-invitation": {
      "filePath": "_auth/community.$entityId.decline-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/project/$entityId/accept-invitation": {
      "filePath": "_auth/project.$entityId.accept-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/project/$entityId/decline-invitation": {
      "filePath": "_auth/project.$entityId.decline-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/project/$projectId/business-model": {
      "filePath": "_auth/project.$projectId.business-model.tsx",
      "parent": "/_auth/project/$projectId"
    },
    "/_auth/project/$projectId/discussion": {
      "filePath": "_auth/project.$projectId.discussion.tsx",
      "parent": "/_auth/project/$projectId",
      "children": [
        "/_auth/project/$projectId/discussion/$discussionId"
      ]
    },
    "/_auth/project/$projectId/kpis": {
      "filePath": "_auth/project.$projectId.kpis.tsx",
      "parent": "/_auth/project/$projectId"
    },
    "/_auth/project/$projectId/overview": {
      "filePath": "_auth/project.$projectId.overview.tsx",
      "parent": "/_auth/project/$projectId"
    },
    "/_auth/tab-entity/$entityId/accept-invitation": {
      "filePath": "_auth/tab-entity.$entityId.accept-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/tab-entity/$entityId/decline-invitation": {
      "filePath": "_auth/tab-entity.$entityId.decline-invitation.tsx",
      "parent": "/_auth"
    },
    "/_unauth/activate/$activateAccountCode/$passwordCode": {
      "filePath": "_unauth.activate.$activateAccountCode.$passwordCode.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/landing/discussion/$discussionId": {
      "filePath": "_unauth.landing.discussion.$discussionId.tsx",
      "parent": "/_unauth/landing"
    },
    "/_unauth/landing/entity/$entityId": {
      "filePath": "_unauth.landing.entity.$entityId.tsx",
      "parent": "/_unauth/landing"
    },
    "/_unauth/landing/project/$projectId": {
      "filePath": "_unauth.landing.project.$projectId.tsx",
      "parent": "/_unauth/landing"
    },
    "/_unauth/landing/projects/$communityId": {
      "filePath": "_unauth.landing.projects.$communityId.tsx",
      "parent": "/_unauth/landing"
    },
    "/_unauth/landing/request/$requestId": {
      "filePath": "_unauth.landing.request.$requestId.tsx",
      "parent": "/_unauth/landing"
    },
    "/_unauth/landing/tab/$tabId": {
      "filePath": "_unauth.landing.tab.$tabId.tsx",
      "parent": "/_unauth/landing"
    },
    "/application-definition/$applicationDefinitionId/application/$applicationId": {
      "filePath": "application-definition/$applicationDefinitionId.application.$applicationId.tsx",
      "parent": "/application-definition/$applicationDefinitionId"
    },
    "/application-definition/$applicationDefinitionId/application/create": {
      "filePath": "application-definition/$applicationDefinitionId.application.create.tsx",
      "parent": "/application-definition/$applicationDefinitionId"
    },
    "/application-definition/$applicationDefinitionId/application/new-application": {
      "filePath": "application-definition/$applicationDefinitionId.application.new-application.tsx",
      "parent": "/application-definition/$applicationDefinitionId"
    },
    "/events/public/join/$token": {
      "filePath": "events.public.join.$token.tsx"
    },
    "/_auth/_community/community/$communityId": {
      "filePath": "_auth/_community/community/$communityId",
      "parent": "/_auth/_community",
      "children": [
        "/_auth/_community/community/$communityId/_admin-panel",
        "/_auth/_community/community/$communityId/about",
        "/_auth/_community/community/$communityId/events",
        "/_auth/_community/community/$communityId/network",
        "/_auth/_community/community/$communityId/requests",
        "/_auth/_community/community/$communityId/resources",
        "/_auth/_community/community/$communityId/",
        "/_auth/_community/community/$communityId/discussions/new",
        "/_auth/_community/community/$communityId/project/$projectId",
        "/_auth/_community/community/$communityId/project/create",
        "/_auth/_community/community/$communityId/application-definitions/",
        "/_auth/_community/community/$communityId/discussions/",
        "/_auth/_community/community/$communityId/projects/",
        "/_auth/_community/community/$communityId/surveys/",
        "/_auth/_community/community/$communityId/application-definition-group/$groupId/responses",
        "/_auth/_community/community/$communityId/application-definitions/$applicationId/responses",
        "/_auth/_community/community/$communityId/discussions/$discussionId/edit",
        "/_auth/_community/community/$communityId/surveys/$surveyId/complete",
        "/_auth/_community/community/$communityId/surveys/$surveyId/responses",
        "/_auth/_community/community/$communityId/surveys/$surveyId/view",
        "/_auth/_community/community/$communityId/discussions/$discussionId/",
        "/_auth/_community/community/$communityId/tab/$tabId/",
        "/_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId",
        "/_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate/$responseId",
        "/_auth/_community/community/$communityId/surveys/$surveyId/answers/$responseId",
        "/_auth/_community/community/$communityId/tab/$tabId/entity/create",
        "/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network",
        "/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings",
        "/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/"
      ]
    },
    "/_auth/_community/community/$communityId/_admin-panel": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel.tsx",
      "parent": "/_auth/_community/community/$communityId",
      "children": [
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/users/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId",
        "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate/$responseId"
      ]
    },
    "/_auth/_community/community/$communityId/about": {
      "filePath": "_auth/_community/community/$communityId/about.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/events": {
      "filePath": "_auth/_community/community/$communityId/events.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/network": {
      "filePath": "_auth/_community/community/$communityId/network.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/requests": {
      "filePath": "_auth/_community/community/$communityId/requests.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/resources": {
      "filePath": "_auth/_community/community/$communityId/resources.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_project/project/$projectId/business-model": {
      "filePath": "_auth/_project/project/$projectId/business-model.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/kpis": {
      "filePath": "_auth/_project/project/$projectId/kpis.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/network": {
      "filePath": "_auth/_project/project/$projectId/network.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/requests": {
      "filePath": "_auth/_project/project/$projectId/requests.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/resources": {
      "filePath": "_auth/_project/project/$projectId/resources.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/settings": {
      "filePath": "_auth/_project/project/$projectId/settings.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/surveys": {
      "filePath": "_auth/_project/project/$projectId/surveys.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_user/account/settings/provider-google-meet": {
      "filePath": "_auth/_user/account.settings.provider-google-meet.tsx",
      "parent": "/_auth/_user/account/settings"
    },
    "/_auth/_user/account/settings/provider-msteams": {
      "filePath": "_auth/_user/account.settings.provider-msteams.tsx",
      "parent": "/_auth/_user/account/settings"
    },
    "/_auth/_user/account/settings/provider-zoom": {
      "filePath": "_auth/_user/account.settings.provider-zoom.tsx",
      "parent": "/_auth/_user/account/settings"
    },
    "/_auth/application-definition/$appDefId/evaluate-application/$applicationId": {
      "filePath": "_auth/application-definition.$appDefId.evaluate-application.$applicationId.tsx",
      "parent": "/_auth/application-definition"
    },
    "/_auth/application-definition/$applicationDefinitionId/application/$applicationId": {
      "filePath": "_auth/application-definition/$applicationDefinitionId.application.$applicationId.tsx",
      "parent": "/_auth/application-definition"
    },
    "/_auth/project/$projectId/discussion/$discussionId": {
      "filePath": "_auth/project.$projectId.discussion.$discussionId.tsx",
      "parent": "/_auth/project/$projectId/discussion"
    },
    "/_auth/_community/community/$communityId/": {
      "filePath": "_auth/_community/community/$communityId/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_project/project/$projectId/": {
      "filePath": "_auth/_project/project/$projectId/index.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_super-admin/super-admin/communities/": {
      "filePath": "_auth/_super-admin/super-admin/communities/index.tsx",
      "parent": "/_auth/_super-admin"
    },
    "/_auth/_super-admin/super-admin/methodologies/": {
      "filePath": "_auth/_super-admin/super-admin/methodologies/index.tsx",
      "parent": "/_auth/_super-admin"
    },
    "/_auth/_super-admin/super-admin/projects/": {
      "filePath": "_auth/_super-admin/super-admin/projects/index.tsx",
      "parent": "/_auth/_super-admin"
    },
    "/_auth/_super-admin/super-admin/statistics/": {
      "filePath": "_auth/_super-admin/super-admin/statistics/index.tsx",
      "parent": "/_auth/_super-admin"
    },
    "/_auth/_super-admin/super-admin/users/": {
      "filePath": "_auth/_super-admin/super-admin/users/index.tsx",
      "parent": "/_auth/_super-admin"
    },
    "/_auth/_community/community/$communityId/discussions/new": {
      "filePath": "_auth/_community/community/$communityId/discussions/new.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/project/$projectId": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId.tsx",
      "parent": "/_auth/_community/community/$communityId",
      "children": [
        "/_auth/_community/community/$communityId/project/$projectId/business-model",
        "/_auth/_community/community/$communityId/project/$projectId/kpis",
        "/_auth/_community/community/$communityId/project/$projectId/network",
        "/_auth/_community/community/$communityId/project/$projectId/requests",
        "/_auth/_community/community/$communityId/project/$projectId/resources",
        "/_auth/_community/community/$communityId/project/$projectId/settings",
        "/_auth/_community/community/$communityId/project/$projectId/surveys",
        "/_auth/_community/community/$communityId/project/$projectId/",
        "/_auth/_community/community/$communityId/project/$projectId/discussions/new",
        "/_auth/_community/community/$communityId/project/$projectId/request/$requestId",
        "/_auth/_community/community/$communityId/project/$projectId/request/new",
        "/_auth/_community/community/$communityId/project/$projectId/discussions/",
        "/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit",
        "/_auth/_community/community/$communityId/project/$projectId/request/edit/$requestId",
        "/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/"
      ]
    },
    "/_auth/_community/community/$communityId/project/create": {
      "filePath": "_auth/_community/community/$communityId/project/create.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_project/project/$projectId/discussions/new": {
      "filePath": "_auth/_project/project/$projectId/discussions/new.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/request/$requestId": {
      "filePath": "_auth/_project/project/$projectId/request.$requestId.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/request/new": {
      "filePath": "_auth/_project/project/$projectId/request.new.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/account/notifications/tab-entity/$entityId/accept-invitation": {
      "filePath": "_auth/account.notifications.tab-entity.$entityId.accept-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/account/notifications/tab-entity/$entityId/decline-invitation": {
      "filePath": "_auth/account.notifications.tab-entity.$entityId.decline-invitation.tsx",
      "parent": "/_auth"
    },
    "/_auth/_community/community/$communityId/application-definitions/": {
      "filePath": "_auth/_community/community/$communityId/application-definitions/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/discussions/": {
      "filePath": "_auth/_community/community/$communityId/discussions/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/projects/": {
      "filePath": "_auth/_community/community/$communityId/projects/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/surveys/": {
      "filePath": "_auth/_community/community/$communityId/surveys/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_project/project/$projectId/discussions/": {
      "filePath": "_auth/_project/project/$projectId/discussions/index.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/community-settings.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/event-settings.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/application-definition-group/$groupId/responses": {
      "filePath": "_auth/_community/community/$communityId/application-definition-group/$groupId/responses.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/application-definitions/$applicationId/responses": {
      "filePath": "_auth/_community/community/$communityId/application-definitions/$applicationId/responses.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/discussions/$discussionId/edit": {
      "filePath": "_auth/_community/community/$communityId/discussions/$discussionId/edit.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/business-model": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/business-model.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/kpis": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/kpis.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/network": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/network.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/requests": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/requests.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/resources": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/resources.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/settings": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/settings.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/surveys": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/surveys.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/surveys/$surveyId/complete": {
      "filePath": "_auth/_community/community/$communityId/surveys/$surveyId.complete.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/surveys/$surveyId/responses": {
      "filePath": "_auth/_community/community/$communityId/surveys/$surveyId/responses.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/surveys/$surveyId/view": {
      "filePath": "_auth/_community/community/$communityId/surveys/$surveyId/view.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_project/project/$projectId/discussions/$discussionId/edit": {
      "filePath": "_auth/_project/project/$projectId/discussions/$discussionId/edit.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_project/project/$projectId/request/edit/$requestId": {
      "filePath": "_auth/_project/project/$projectId/request.edit.$requestId.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/community/$communityId/application-definition/$appDefId/evaluate/$applicationId": {
      "filePath": "_auth/community.$communityId.application-definition.$appDefId.evaluate.$applicationId.tsx",
      "parent": "/_auth"
    },
    "/_auth/_community/community/$communityId/discussions/$discussionId/": {
      "filePath": "_auth/_community/community/$communityId/discussions/$discussionId/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/index.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/tab/$tabId/": {
      "filePath": "_auth/_community/community/$communityId/tab/$tabId/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_project/project/$projectId/discussions/$discussionId/": {
      "filePath": "_auth/_project/project/$projectId/discussions/$discussionId/index.tsx",
      "parent": "/_auth/_project"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId": {
      "filePath": "_auth/_community/community/$communityId/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate/$responseId": {
      "filePath": "_auth/_community/community/$communityId/application-definitions/$applicationId/evaluate.$responseId.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/discussions/new": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/discussions/new.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/request/$requestId": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/request.$requestId.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/request/new": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/request.new.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/surveys/$surveyId/answers/$responseId": {
      "filePath": "_auth/_community/community/$communityId/surveys/$surveyId.answers.$responseId.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/tab/$tabId/entity/create": {
      "filePath": "_auth/_community/community/$communityId/tab/$tabId/entity/create.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/community/$communityId/admin-panel/application-definition/$appDefId/evaluate/$applicationId": {
      "filePath": "_auth/community.$communityId.admin-panel.application-definition.$appDefId.evaluate.$applicationId.tsx",
      "parent": "/_auth"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/activity-feed/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/circle-management/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/overview-projects/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/requests-status/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/startup-kpis/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/startups-progress/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/statistics/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/users/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/users/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/project/$projectId/discussions/": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/discussions/index.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/responses.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/responses.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/$formId.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/$formId.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/$formId.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/$formId.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/create.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/kpis.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/people.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/planner.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/preview.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/responses.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/view.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/edit.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/project/$projectId/request/edit/$requestId": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/request.edit.$requestId.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network": {
      "filePath": "_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/network.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings": {
      "filePath": "_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/settings.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/application/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/evaluation/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/methodology/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/forms/survey/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/pages/$pageId/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/programs/$programId/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/surveys/$surveyId/index.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/": {
      "filePath": "_auth/_community/community/$communityId/project/$projectId/discussions/$discussionId/index.tsx",
      "parent": "/_auth/_community/community/$communityId/project/$projectId"
    },
    "/_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/": {
      "filePath": "_auth/_community/community/$communityId/tab/$tabId/entity/$entityId/index.tsx",
      "parent": "/_auth/_community/community/$communityId"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definition-group/$groupId/evaluate-rounds/$applicationResponseGroupId.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    },
    "/_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate/$responseId": {
      "filePath": "_auth/_community/community/$communityId/_admin-panel/admin-panel/application-definitions/$applicationId/evaluate.$responseId.tsx",
      "parent": "/_auth/_community/community/$communityId/_admin-panel"
    }
  }
}
ROUTE_MANIFEST_END */
